'use strict';
import angular from 'angular'
import $ from 'jquery'
import _ from 'lodash'
import moment from 'moment';
import modalUpdateDueDateHtmlUrl from '../../tasks/views/modal_updateDueDate.html'
import adminTasksHtmlUrl from '../../../views/shared/adminTasks.html'
import taskAssignmentHistoryHtmlUrl from '../views/modal_taskAssignmentHistory.html'

angular.module('tasks.ctrls', [])
    .controller('MyTasksViewController', MyTasksViewController)
    .controller('MyTasksController', MyTasksController)
    .controller('AdminTasksController', AdminTasksController)
    .controller('AddAdminTasksController', AddAdminTasksController)
    .controller('UpdateDueDateModalController', UpdateDueDateModalController);

MyTasksViewController.$inject = ['$rootScope', '$scope', '$window', '$state', '$stateParams', 'TaskService', 'FormService', 'DisplayService', 'OrdersService', 'UserService', 'MediaService', 'CommentService', 'ProductService', '$ioAlert', '$filter', 'QueuesService', '$modal', '$comments', 'PageNumberService', 'ModalService', 'creativesService', 'CreativeServicePro', 'ClusterService', 'ServiceService', 'CurrentUser', '$confirm','AppConfig'];

function MyTasksViewController($rs, $scope, $window, $state, $stateParams, TaskService, FormService, DisplayService, OrdersService, UserService, MediaService, CommentService, ProductService, $ioAlert, $filter, QueuesService, $modal, $comments, PageNumberService, ModalService, creativesService, CreativeServicePro, ClusterService, ServiceService, CurrentUser, $confirm, AppConfig) {
    var STATUS_TASK_ASSIGNMENT_COMPLETE = 19;
    var STATUS_TASK_ASSIGNMENT_CLOSED = 20;
    var STATUS_TASK_ASSIGNMENT_REJECTED = 25;
    var STATUS_TASK_ASSIGNMENT_FAILED = 26;
    var STATUS_NAME_TASK_ASSIGNMENT_PROCESSING = 'Processing';
    var MAX_RPIORITY = 10;
    var MIN_PRIORITY = 1;
    var CALENDAR_SUCCESS_MESSAGE = 'Task assignment successfully added to calendar';

    $scope.task = null;
    $scope.taskAssignment = null;
    $scope.comments = null;
    $scope.order = {};
    $scope.assignedUser = null;
    $scope.isAssigned = false;
    $scope.isComplete = false;
    $scope.isClosed = false;
    $scope.isFollowed = false;
    $scope.isRejected = false;
    $scope.isRejectable = false;
    $scope.isOwner = false;
    $scope.isVendor = false;
    $scope.isLineItemTask = false;
    $scope.isOrderTask = false;
    $scope.isFlightTask = false;
    $scope.isClientTask = false;
    $scope.isSharedTask = false;
    $scope.isAutoSubmission = false;
    $scope.fromMyQueues = false;
    $scope.fromQueueManager = false;
    $scope.fromWorkflowClient = false;
    $scope.submitTaskData = false;
    $scope.loadComplete = false;
    $scope.loadFail = false;
    $scope.showVendorPushControl = false;
    $scope.showServiceMapperLink = false;
    $scope.taskReqProcess = false;
    $scope.isBtnDisabled = false;
    $scope.currentUserId = $rs.userRole.id;
    $scope.realCreativeFilenames = [];
    $scope.creativesReceived = false;
    $scope.entityReceived = false;  // entity is either client, order, lineitem, or flight.
    $scope.creatives = [];
    $scope.connectCalendar = false;
    $scope.calendarFeatureEnabled = $rs.util.isModuleAvailable('iotool_cal_events');
    $scope.hasCalendarEvent = false;
    $scope.isProcessing = false;
    $scope.uploadFileSetIndex = 1;
    $scope.uploadFileSet = new Set();

    // Specific to line item tasks
    $scope.lineItem = null;
    $scope.lineItems = {};
    $scope.lineItemCount = 0;
    $scope.lineItemTaskDetails = null;
    $scope.productFields = {};
    $scope.productDisplayGroups = {};
    $scope.tapOrdersService = null;

    // Specific to flight tasks
    $scope.fromFlights = false;
    $scope.lineItemId = null;
    $scope.flight = null;
    $scope.flightAttrs = null;

    // Specific to client tasks
    $scope.client = null;

    // Dynamic form
    $scope.model = {};
    $scope.schema = {};
    $scope.form = [];
    $scope.entireForm = [];
    $scope.formParentChildInfo = {};
    $scope.formFieldMap = {};
    $scope.formFields = null;
    $scope.caretClass = "icon-caret-down";
    $scope.auditArray = {};
    $scope.pushTooltip = 'Push to Vendor';
    $scope.user_is_vendor = false;

    $scope.commentObj = {
        quickComment: null
    };

    if ($stateParams.fromPage === 'queueManager') {
        $scope.fromQueueManager = true;
    } else if ($stateParams.myQueues && !$stateParams.orderId) {
        $scope.fromMyQueues = true;
    } else if ($stateParams.clientId) {
        $scope.fromWorkflowClient = true;
    } else if ($stateParams.orderId) {
        $scope.fromOrders = true;
    } else if ($stateParams.flightId) {
        $scope.fromFlights = true;
        $scope.lineItemId = $stateParams.lineItemId;  // To go back to view line item page
    } else if ($stateParams.lineItemId) {
        $scope.fromLineItems = true;
    }

    if ($window.location.href.includes('calEventAdded')) {
        $ioAlert.show('', CALENDAR_SUCCESS_MESSAGE, 'success');
    }

    $scope.openGoals = function(goal) {
        let path = AppConfig.TA_URL;
        if ($rs.user.user.use_nui) {
            path = AppConfig.NUI_PATH;
        }
        if (goal.is_old === "0" || !goal.is_old) {
            $window.open(path + `#/sup/goals?id=${goal.id}`, '_self');
        } else {
            const start_date = moment.unix(goal.start).utc().format('YYYY-MM-DD');
            const end_date = moment.unix(goal.end).utc().format('YYYY-MM-DD');
            $window.open(path + `#/goals?start_date=${start_date}&end_date=${end_date}`, '_self');
        }
    };

    /*
    *  Handle get task assignments history
    */
    $scope.getTaskAssignmentHistory = function(taskAssignment) {
        TaskService.getTaskAssignmentHistory(taskAssignment.id).then(function(response) {
            if(response) {
                $scope.taskAssignmentHistory = response;

                _.each($scope.taskAssignmentHistory, function(history) {

                    //build action user full name
                    if(history.action_user_first_name && history.action_user_last_name) {
                        history.action_user_full_name = history.action_user_first_name + ' ' + history.action_user_last_name;
                    } else if(history.action_user_first_name) {
                        history.action_user_full_name = history.action_user_first_name;
                    } else if(history.action_user_last_name) {
                        history.action_user_full_name =  history.action_user_last_name;
                    } else {
                        history.action_user_full_name = 'System';
                    }

                    //build assigned user full name
                    if(history.assigned_user_first_name && history.assigned_user_last_name) {
                        history.assigned_user_full_name = history.assigned_user_first_name + ' ' + history.assigned_user_last_name;
                    } else if(history.assigned_user_first_name) {
                        history.assigned_user_full_name = history.assigned_user_first_name;
                    } else if(history.assigned_user_last_name) {
                        history.assigned_user_full_name =  history.assigned_user_last_name;
                    } else {
                        history.assigned_user_full_name = 'Unassigned';
                    }
                })

                showTaskAssignmentHistory(taskAssignment);
            }
        }, function(error) {
            console.log("Error getting task assignment history");
            $ioAlert.show('ERROR!', 'Error getting task assignment history. Please try again later.', 'error');
        })
    }

    /*
    * Handle showing task assignment history
    */
    var showTaskAssignmentHistory = function(taskAssignment) {
        $modal.open({
            animation: true,
            controller: function($scope, $modalInstance, taskAssignmentHistory){

                $scope.taskHistory = taskAssignmentHistory.history;
                $scope.task = taskAssignmentHistory.taskAssignment;

                // Close the modal popup
                $scope.cancel = function() {
                    $modalInstance.dismiss();
                };
            },
            templateUrl: taskAssignmentHistoryHtmlUrl,
            backdrop: 'static',
            size: 'lg',
            resolve: {
                taskAssignmentHistory: function() {
                    return {
                        history: $scope.taskAssignmentHistory,
                        taskAssignment: taskAssignment
                    };
                }
            },
            windowClass: 'magictime zoomInSmooth modal-overflow in'
        }).result.then(function(data) {})
    }

    var getTaskAssignment = function() {
        TaskService.getTaskAssignment($stateParams.taskId).then(function(success) {
            $scope.taskAssignment = TaskService.taskAssignment;

            taskIsFollowed();
            if ($scope.taskAssignment) {
                if ($stateParams.lineItemId && $scope.taskAssignment.reference_table == 'line_item') {
                    $scope.taskAssignment.lineItemId = $stateParams.lineItemId;
                    $scope.taskAssignment.line_item_id = $stateParams.lineItemId;
                    $scope.taskAssignment.reference_table_row_id = $stateParams.lineItemId;
                }
                $scope.isComplete = ($scope.taskAssignment.status_id == STATUS_TASK_ASSIGNMENT_COMPLETE);
                $scope.isClosed = ($scope.taskAssignment.status_id == STATUS_TASK_ASSIGNMENT_CLOSED);
                $scope.isRejected = ($scope.taskAssignment.status_id == STATUS_TASK_ASSIGNMENT_REJECTED);
                $scope.isProcessing = ($scope.taskAssignment.status_name == STATUS_NAME_TASK_ASSIGNMENT_PROCESSING);
                $scope.isOwner = ($scope.userRole.id == $scope.taskAssignment.user_id);
                $scope.isSharedTask = ($scope.taskAssignment.shared == '1');
                getTask();
                getQueue();

                if ($scope.taskAssignment.logged_time) {
                    var hours = Math.floor($scope.taskAssignment.logged_time / 60);
                    var minutes = $scope.taskAssignment.logged_time % 60;
                    $scope.taskAssignment.logged_time_date = new Date(1970, 0, 1, hours, minutes, 0);
                    if (minutes < 10) {
                        $scope.taskAssignment.logged_time_display = hours + ":0" + minutes;
                    } else {
                        $scope.taskAssignment.logged_time_display = hours + ":" + minutes;
                    }
                }

                if ($scope.taskAssignment.user_id) {
                    $scope.isAssigned = true;
                    UserService.getUser($scope.taskAssignment.user_id).then(function(success) {
                        $scope.assignedUser = UserService.user;
                        $scope.loadComplete = true;
                    }, function(error) {
                        console.log("Error getting user " + $scope.taskAssignment.user_id);
                    });
                } else {
                    $scope.loadComplete = true;
                }
                if ($scope.taskAssignment.due_date && $scope.taskAssignment.escalate_date) {
                    $scope.taskAssignment.dueDate = new Date($scope.taskAssignment.due_date + " 00:00:00");
                }
            } else {
                $ioAlert.show('Error!', 'An error occurred loading the task details.', 'error');
                $scope.loadComplete = true;
            }
        }, function(error) {
            if (error && error.code === 403) {
                $scope.loadFail = true;
                $scope.loadComplete = false;
                $scope.error = error;
            } else {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            }
        });
    };

    /*
     * Get Task
     */
    var getTask = function() {
        TaskService.getTask($scope.taskAssignment.task_id).then(function(success) {
            $scope.task = TaskService.task;

            if ($scope.task.rejectable == '1' && !$scope.isRejected) {
                $scope.isRejectable = true;
            }
            if ($scope.task.time_tracking == '1') {
                $scope.timeTracking = true;
                if ($scope.task.time_tracking_estimate) {
                    const time = $scope.task.time_tracking_estimate.split(':');
                    $scope.timeTrackingH = time[0];
                    $scope.timeTrackingM = time[1];
                }
            }
            if ($scope.task.time_tracking_required == '1') {
                $scope.timeTrackingRequired = true;
            }
            if($scope.task.create_goal == '1') {
                $scope.createGoal = true;
            }

            if ((($scope.task.vendor_name && $scope.task.vendor_name.length != 0) ||
                ($scope.task.event_names && $scope.task.event_names.length != 0) ||
                ($scope.task.create_goal == 1)) && $scope.isOwner && !$scope.isRejected) {
                $scope.showVendorPushControl = true;
                $scope.pushTooltip = $scope.task.create_goal == 1 ? 'Push Goal' : 'Push to Vendor';
            }

            $scope.connectCalendar = ($scope.task.connect_calendar == '1');

            if ($scope.calendarFeatureEnabled && $scope.connectCalendar) {
                hasCalendarEvent();
            }

            $scope.creativesReceived = false;
            $scope.entityReceived = false;
            if ($scope.taskAssignment.order_id) {
                OrdersService.getOrder($scope.taskAssignment.order_id, false, $scope.taskAssignment.id).then(function(success) {
                    $scope.order = OrdersService.order;
                    if ($scope.task.reference_table == 'line_item') {
                        $scope.isLineItemTask = true;
                        getLineItems();
                        getCreatives($scope.taskAssignment.task_id);

                    } else if ($scope.task.reference_table == 'order') {
                        $scope.isOrderTask = true;
                        getCreatives($scope.taskAssignment.task_id);
                        getOrderComments();
                        $scope.entityReceived = true;
                        loadForm($scope.taskAssignment.task_id);
                        //$scope.loadComplete = true;
                    } else if ($scope.task.reference_table == 'flight') {
                        $scope.isFlightTask = true;
                        getFlight($scope.taskAssignment.reference_table_row_id);
                        getCreatives($scope.taskAssignment.task_id);
                    }
                }, function(error) {
                    if (error && error.code === 403) {
                        $ioAlert.show('Error!', error.message, 'error');
                    } else {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    }
                });
            } else {
                // Client task
                $scope.isClientTask = true;
                getClient($scope.taskAssignment.reference_table_row_id);
                getCreatives($scope.taskAssignment.task_id);
            }
        }, function(error) {
            console.log("Error getting task " + $scope.taskAssignment.task_id);
        });
    }

    /*
     * Get queue
     */
    var getQueue = function() {
        QueuesService.getQueue($scope.taskAssignment.queue_id).then(function(success) {
            $scope.currentQueue = QueuesService.queue;
        }, function(error) {
            console.log("Error getting queue " + $scope.taskAssignment.queue_id);
        });
    }

    var hasCalendarEvent = function() {
        TaskService.hasCalendarEvent($scope.taskAssignment.id).then(function(success) {
            $scope.hasCalendarEvent = success.data;
        }, function(error) {
            console.log("Error getting queue " + $scope.taskAssignment.queue_id);
        });
    }

    let getClient = function(clientId) {
        UserService.getClient(clientId).then(function(success) {
            $scope.client = UserService.client;
            getClientComments();
            $scope.entityReceived = true;
            loadForm($scope.taskAssignment.task_id);
        }, function(error) {
            console.log("Error getting client " + clientId);
        });
    }

    let getFlight = function(flightId) {
        OrdersService.getFlight(flightId, $scope.taskAssignment.id).then(function(success) {
            $scope.flight = OrdersService.flight;
            $scope.flightAttrs = OrdersService.flightAttrs;
            getFlightComments();
            $scope.entityReceived = true;
            loadForm($scope.taskAssignment.task_id);
        }, function(error) {
            console.log("Error getting flight " + flightId);
        });
    }

    var taskIsFollowed = function() {
        TaskService.getFollowedTaskAssignmentsForCurrentUser().then(function(success) {
            if (TaskService.taskAssignments.length) {
                for (var i = 0; i < TaskService.taskAssignments.length; i++) {
                    if (TaskService.taskAssignments[i].hasOwnProperty('id')) {
                        if (
                            $scope.taskAssignment &&
                            $scope.taskAssignment.hasOwnProperty('id') &&
                            $scope.taskAssignment.id === TaskService.taskAssignments[i].id) {
                            $scope.isFollowed = true;
                        }
                    }
                }
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    const getLineItems = function() {
        TaskService.getOpenLineItemsForTask($scope.taskAssignment.id).then(function(success) {
            const lineItems = TaskService.lineItems;

            $scope.lineItemCount = lineItems.length;
            const lineItemPageNames = [];
            getLineItemComments();

            for (let i = 0; i < lineItems.length; i++) {
                for (let j = 0; j < $scope.order.lineItems.length; j++) {
                    if (lineItems[i] === $scope.order.lineItems[j].id) {
                        lineItemPageNames[i] = {
                            text: lineItems[i]
                        };
                        $scope.lineItems[lineItems[i]] = $scope.order.lineItems[j];

                        if (lineItems[i] === $scope.taskAssignment.reference_table_row_id) {
                            $scope.lineItem = $scope.order.lineItems[j];
                            $scope.entityReceived = true;
                            loadForm($scope.taskAssignment.task_id);
                            generateServiceMapperLink($scope.lineItem);
                        }
                        getProductFields(lineItems[i]);
                        getGoals(lineItems[i]);
                    }
                }
            }
            PageNumberService.setPages(lineItemPageNames);
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    const getGoals = function(lineItemId) {
        OrdersService.getGoalsForLineItem(lineItemId).then(function(goals) {
            if (goals && goals.length !== 0) {
                $scope.lineItems[lineItemId].goals = goals;
            }
        }, function(error) {
            console.log("Error getting goals for line item: " + lineItem.id + " " + error);
        })
    };

    $scope.navigateToTask = function(comment) {
        switch (comment.table_name) {
            case 'order':
                $state.go('viewOrderTask', {
                    orderId: comment.order_id,
                    taskId: comment.task_assignment_id,
                    fromPage: 'order'
                });
                break;
            case 'line_item':
                $state.go('viewLineItemTask', {
                    lineItemId: comment.line_item_id,
                    taskId: comment.task_assignment_id,
                    fromPage: 'lineitem'
                });
                break;
            case 'flight':
                $state.go('viewFlightTask', {
                    flightId: comment.flight_id,
                    lineItemId: comment.line_item_id,
                    taskId: comment.task_assignment_id,
                    fromPage: 'flight'
                });
                break;
        }
    };

    $scope.navigateToLineItem = function(lineItemId) {
        $state.go('viewLineItem', {
            lineItemId: lineItemId
        });
    };

    $scope.navigateToFlight = function(lineItemId, flightId) {
        $state.go('viewLineItem', {
            lineItemId: lineItemId,
            flightId: flightId
        });
    };

    $scope.navigateToOrder = function(orderId) {
        $state.go('viewOrder', {
            id: orderId
        });
    };

    /*
     *   Handle delete comment for tasks
     */
    $scope.deleteComment = function(commentId) {
        $confirm.open({
            size: 'sm',
            text: 'Are you sure you want to delete this Comment?'
        }).then(function() {
            CommentService.deleteComment(commentId).then(function() {
                _.remove($scope.comments, function(comment) {
                    return comment.id == commentId;
                });
                $ioAlert.show('Comment deleted', 'Comment has been successfully deleted', 'success');
            }, function() {
                console.log("error deleting comment");
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }, function() {})
    };

    var genItemIds = function(lineItems) {
        var returnArray = [];
        for (var i = 0; i < lineItems.length; i++) {
            returnArray.push(lineItems[i].order_id);
        }
        return returnArray;
    };

    var generateServiceMapperLink = function(lineItem) {
        if (lineItem && lineItem.product_service_id && lineItem.product_service_id > 0) {
            ServiceService.getService(lineItem.product_service_id).then(function(success) {
                if (ServiceService.service && ServiceService.service[0]) {
                    $scope.showServiceMapperLink = true;
                    $scope.tapOrdersService = ServiceService.service[0];
                }
            }, function(error) {});
        }
    };

    var getCreatives = function(taskId = null) {
        if ($scope.order && $scope.order.id) {
            if ($scope.isOrderTask) {
                MediaService.getOrderCreatives($scope.order.id).then(function(success) {
                    $scope.creatives = MediaService.creatives;
                    $scope.creativesReceived = true;
                    loadForm(taskId);
                }, function(error) {
                    console.log("Error getting creatives for order: " + $scope.taskAssignment.reference_table_row_id);
                    $scope.creativesReceived = true;
                    loadForm(taskId);
                });
            } else if ($scope.isLineItemTask) {
                MediaService.getLineItemCreatives($scope.taskAssignment.reference_table_row_id).then(function(success) {
                    $scope.creatives = [];
                    $scope.creatives = $scope.creatives.concat(MediaService.creatives);
                    $scope.creativesReceived = true;
                    loadForm(taskId);
                }, function(error) {
                    console.log("Error getting creatives for line item: " + $scope.taskAssignment.reference_table_row_id);
                    $scope.creativesReceived = true;
                    loadForm(taskId);
                });
            } else if ($scope.isFlightTask) {
                MediaService.getFlightCreatives($scope.taskAssignment.reference_table_row_id).then(function(success) {
                    $scope.creatives = [];
                    $scope.creatives = $scope.creatives.concat(MediaService.creatives);
                    $scope.creativesReceived = true;
                    loadForm(taskId);
                }, function(error) {
                    console.log("Error getting creatives for flight: " + $scope.taskAssignment.reference_table_row_id);
                    $scope.creativesReceived = true;
                    loadForm(taskId);
                });
            }
        } else if ($scope.isClientTask) {
            MediaService.getClientCreatives($scope.taskAssignment.reference_table_row_id).then(function(success) {
                $scope.creatives = [];
                $scope.creatives = $scope.creatives.concat(MediaService.creatives);
                $scope.creativesReceived = true;
                loadForm(taskId);
            }, function(error) {
                console.log("Error getting creatives for client: " + $scope.taskAssignment.reference_table_row_id);
                $scope.creativesReceived = true;
                loadForm(taskId);
            });
        }
    };

    var getLineItemComments = function() {
        $scope.isCommentLoad = true;
        CommentService.getLineItemComments($scope.taskAssignment.reference_table_row_id).then(function(success) {
            $scope.comments = CommentService.comments;
            $scope.isCommentLoad = false;
        }, function(error) {
            $scope.isCommentLoad = false;
            console.log("Error getting comments for line item: " + $scope.taskAssignment.reference_table_row_id);
        });
    };

    var getOrderComments = function() {
        $scope.isCommentLoad = true;
        CommentService.getOrderComments($scope.taskAssignment.reference_table_row_id).then(function(success) {
            $scope.comments = CommentService.comments;
            $scope.isCommentLoad = false;
        }, function(error) {
            console.log("Error getting comments for order: " + $scope.taskAssignment.reference_table_row_id);
            $scope.isCommentLoad = false;
        });
    };

    var getFlightComments = function() {
        $scope.isCommentLoad = true;
        CommentService.getFlightComments($scope.taskAssignment.reference_table_row_id).then(function(success) {
            $scope.comments = CommentService.comments;
            $scope.isCommentLoad = false;
        }, function(error) {
            console.log("Error getting comments for flight: " + $scope.taskAssignment.reference_table_row_id);
            $scope.isCommentLoad = false;
        });
    };

    var getClientComments = function() {
        $scope.isCommentLoad = true;
        CommentService.getClientComments($scope.taskAssignment.reference_table_row_id).then(function(success) {
            $scope.comments = CommentService.comments;
            $scope.isCommentLoad = false;
        }, function(error) {
            console.log("Error getting comments for client: " + $scope.taskAssignment.reference_table_row_id);
            $scope.isCommentLoad = false;
        });
    };

    $scope.commentSubmitDisabled = false;

    $scope.addQuickComment = function() {
        if (!$scope.commentObj.quickComment) {
            $ioAlert.show('Error!', 'Please enter a comment.', 'error');
            return;
        }
        $scope.commentSubmitDisabled = true;
        var entityType = '';
        entityType = $scope.isLineItemTask ? 'line_item' : entityType;
        entityType = $scope.isOrderTask ? 'order' : entityType;
        entityType = $scope.isFlightTask ? 'flight' : entityType;
        entityType = $scope.isClientTask ? 'client' : entityType;
        CommentService.addComment(entityType, $scope.taskAssignment.reference_table_row_id, $scope.commentObj.quickComment,
            false, false, null, $scope.taskAssignment.id).then(function(success) {
            $scope.commentObj.quickComment = null;
            $scope.commentSubmitDisabled = false;
            updateComments(entityType);
        }, function(error) {
            $scope.commentSubmitDisabled = false;
            console.log("Error saving comment for " + entityType + $scope.taskAssignment.reference_table_row_id);
        });
    };

    $scope.upload = function(creativeFiles) {
        if (creativeFiles.length) {
            angular.forEach(creativeFiles, function(file, index) {
                if (!(/^[A-Za-z0-9_.@()-\s]+\.[^.]+$/i.test(file.name))) {
                    console.log('Warning, filename contains metacharacters.');
                }
                if (index == 0) {
                    $ioAlert.show('', "Creatives are being uploaded, please don't refresh the page. You can check the status in the notifications tab.", 'success');
                }

                if ($scope.isOrderTask) {
                    CreativeServicePro.getImgSignature({
                        orderId: $scope.order.id,
                        fileName: file.name
                    }).then(function (success) {
                        var additionalParams = {
                            "from": "order",
                            "orderId": $scope.order.id,
                            "libraryCreative": "no",
                            "file_name": file.name,
                            "file_size": file.size,
                            "isTasksPage": true,
                            "sharedTask": $scope.taskAssignment.shared
                        };
                        $rs.$broadcast('cloudinaryImageUpload', success, file, additionalParams);
                        if (index === creativeFiles.length - 1) {
                            $scope.uploadMedia = {};
                        }
                    }, function (error) {
                        $ioAlert.show('Error!', 'Could not get order img signature. ' + error.data, 'error');
                        console.log(error);
                    });
                } else if ($scope.isLineItemTask) {
                    CreativeServicePro.getImgSignature({
                        lineItemId: $scope.lineItem.id,
                        fileName: file.name
                    }).then(function (success) {
                        var additionalParams = {
                            "from": "lineItem",
                            "lineItemId": $scope.lineItem.id,
                            "libraryCreative": "no",
                            "file_name": file.name,
                            "file_size": file.size,
                            "isTasksPage": true,
                            "sharedTask": $scope.taskAssignment.shared
                        };
                        $rs.$broadcast('cloudinaryImageUpload', success, file, additionalParams);
                        if (index === creativeFiles.length - 1) {
                            $scope.uploadMedia = {};
                        }
                    }, function (error) {
                        $ioAlert.show('Error!', 'Could not get line item img signature. ' + error.data, 'error');
                        console.log(error);
                    });
                } else if ($scope.isFlightTask) {
                    CreativeServicePro.getImgSignature({
                        flightId: $scope.flight.id,
                        fileName: file.name
                    }).then(function (success) {
                        var additionalParams = {
                            "from": "flight",
                            "flightId": $scope.flight.id,
                            "libraryCreative": "no",
                            "file_name": file.name,
                            "file_size": file.size,
                            "isTasksPage": true,
                            "sharedTask": $scope.taskAssignment.shared
                        };
                        $rs.$broadcast('cloudinaryImageUpload', success, file, additionalParams);
                        if (index === creativeFiles.length - 1) {
                            $scope.uploadMedia = {};
                        }
                    }, function (error) {
                        $ioAlert.show('Error!', 'Could not get flight img signature. ' + error.data, 'error');
                        console.log(error);
                    });
                } else if ($scope.isClientTask) {
                    CreativeServicePro.getImgSignature({
                        clientId: $scope.client.id,
                        fileName: file.name
                    }).then(function (success) {
                        var additionalParams = {
                            "from": "client",
                            "clientId": $scope.client.id,
                            "libraryCreative": "no",
                            "file_name": file.name,
                            "file_size": file.size,
                            "isTasksPage": true,
                            "sharedTask": $scope.taskAssignment.shared
                        };
                        $rs.$broadcast('cloudinaryImageUpload', success, file, additionalParams);
                        if (index === creativeFiles.length - 1) {
                            $scope.uploadMedia = {};
                        }
                    }, function (error) {
                        $ioAlert.show('Error!', 'Could not get client img signature. ' + error.data, 'error');
                        console.log(error);
                    });
                }
            });
        }
    }

    var getLineItemActivity = function(id) {
        $scope.lineItemActivity = {};
        OrdersService.getActivity('line_item', id).then(function(success) {
            $scope.lineItemActivity[id] = OrdersService.lineItemActivity;
            var arrMap = {};
            if ($scope.lineItemActivity[id] != null) {
                for (var i = 0, len = $scope.lineItemActivity[id].length; i < len; i++) {
                    if ($scope.lineItemActivity[id][i].action?.startsWith('update')) {
                        var jsonObj = JSON.parse($scope.lineItemActivity[id][i].delta);
                        var keys = Object.keys(jsonObj);
                        keys.forEach(function(value) {
                            var obj = {};
                            obj.field = value;
                            obj.before = jsonObj[value].before;
                            obj.after = jsonObj[value].after;
                            obj.date = $scope.lineItemActivity[id][i].created_at;
                            if (arrMap[value]) {
                                arrMap[value].push(obj);
                            } else {
                                arrMap[value] = [obj];
                            }
                        });
                    }
                };
                $scope.auditArray[id] = arrMap;

                //Helper function to update the audit logging
                for (var i in $scope.productDisplayGroups[id]) {
                    _.each($scope.productDisplayGroups[id][i].data, function(data) {
                        if (data.productFieldName && $scope.auditArray[id][data.productFieldName]) {
                            data.isEdited = true;
                            data.fieldAuditHistory = $scope.auditArray[id][data.productFieldName];
                        } else {
                            data.isEdited = false;
                        }
                    });
                }
            };
        }, function(error) {
            console.log("Error getting line item activity for line item: " + $scope.lineItemId);
        });
    };

    const hiddenByParent = function(field, fieldList, entity) {
        if (field.parent_id) {
            let parent_field = null;
            for (let i = 0; i < fieldList.length; i++) {
                if (fieldList[i]['id'] == field.parent_id) {
                    parent_field = fieldList[i];
                    break;
                }
            }

            if (parent_field && entity.hasOwnProperty(parent_field.field_name)) {
                let parentValues = entity[parent_field.field_name];
                if (Array.isArray(parentValues)) {
                    if (Array.isArray(parentValues[0])) {
                        for (let i in parentValues) {
                            if (field.parent_trigger_id.indexOf(parentValues[i][0]) != -1) { // multi select
                                return false;
                            }
                        }
                    } else if (field.parent_trigger_id.indexOf(parentValues[0]) != -1) { // single select
                        return false;
                    }
                } else if (field.parent_trigger_id.indexOf(parentValues) != -1) { // checkbox
                    return false;
                }
                return true;
            } else {
                return true;
            }
        }
        return false;
    }

    var getProductFields = function(id) {
        var lineItem = $scope.lineItems[id];
        var productId = $scope.lineItems[id].product_id;
        ProductService.getProductFieldGroupsForDisplay(productId).then(function(success) {
            // Add a display group with static information
            var staticInfoSection = {};
            staticInfoSection.title = "";
            staticInfoSection.data = [];

            var productName = {};
            var orderId = {};
            var statusName = {};
            productName['Product Name'] = lineItem.product_name;
            orderId['Order Id'] = lineItem.order_id;
            statusName['Status Name'] = lineItem.status_name;
            $scope.locationpickerOptions = {
                location: {
                    latitude: 0,
                    longitude: 0
                },
                inputBinding: {
                    //latitudeInput: $('#map_latitude'),
                    //longitudeInput: $('#map_longitude'),
                    //radiusInput: $('#map_radius'),
                    //locationNameInput: $('#map_address')
                },
                radius: 0,
                enableAutocomplete: true
            };

            staticInfoSection.data.push(productName);
            staticInfoSection.data.push(orderId);
            staticInfoSection.data.push(statusName);
            $scope.productDisplayGroups[id] = {};
            $scope.productDisplayGroups[id][0] = staticInfoSection;

            // Process dynamic product field groups
            var productFieldGroups = ProductService.productFieldGroups;

            for (var x = 0; x < productFieldGroups.length; x++) {
                var productFieldGroup = productFieldGroups[x];
                if (productFieldGroup.hideForCondition && productFieldGroup.hideForCondition.includes($rs.userRole.role_id)) {
                    continue;
                }
                var section = {};
                section.title = productFieldGroup.group_name;
                section.data = [];
                $scope.productDisplayGroups[id][productFieldGroup.id] = section;
            }

            // Add product fields to respective group
            ProductService.getProductFieldsForDisplay(productId).then(function(success) {
                $scope.productFields[id] = ProductService.productFields;
                for (let i = 0; i < $scope.productFields[id].length; i++) {
                    const productField = $scope.productFields[id][i];
                    if (!hiddenByParent(productField, $scope.productFields[id], $scope.lineItems[id])) {
                        if (productField.input_type === "readonly" && productField.default_value) {
                            $scope.lineItems[id][productField.field_name] = productField.default_value;
                        }
                        if ($scope.lineItems[id].hasOwnProperty(productField.field_name)) {
                            let group = $scope.productDisplayGroups[id][productField.group_id];
                            if (!group) {
                                continue;
                            }
                            let displayPair = DisplayService.applyTransformation(productField, $scope.lineItems[id][productField.field_name]);
                            displayPair.productFieldType = productField.input_type;
                            displayPair.productFieldType = ['hyperlink'].includes(productField.data_type)  ?
                                productField.data_type : productField.input_type;
                            displayPair.productFieldName = productField.field_name;
                            group.data.push(displayPair);
                        }
                    } else {
                        delete $scope.lineItems[id][productField.field_name];
                    }
                }
                // Remove empty sections from groups
                for (let index in $scope.productDisplayGroups[id]) {
                    if ($scope.productDisplayGroups[id].hasOwnProperty(index)) {
                        if ($scope.productDisplayGroups[id][index].data.length == 0) {
                            delete $scope.productDisplayGroups[id][index];
                        }
                    }
                }
                //$scope.loadComplete = true;
                getLineItemActivity(id);
            }, function(error) {
                console.log("Error getting product fields for product: " + $scope.lineItems[id].product_id);
            });
        }, function(error) {
            console.log("error getting product field groups for product: " + $scope.lineItems[id].product_id);
        });
    };

    var rejectTask = function() {
        TaskService.rejectTaskAssignment($scope.taskAssignment.id).then(function(success) {
            if ($scope.fromMyQueues) {
                $scope.backToQueues();
            } else if ($scope.fromQueueManager) {
                $scope.backToQueueManager();
            } else if ($scope.fromWorkflowClient) {
                $scope.backToWorkflowClient();
            } else if ($scope.fromOrders) {
                $scope.backToOrder();
            } else if ($scope.fromLineItems) {
                $scope.backToLineItem();
            } else if ($scope.fromFlights) {
                $scope.backToFlight();
            } else {
                $scope.backToTasks();
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
        });
    };

    var assignToUser = function(task, user) {
        if (task && user) {
            TaskService.assignTaskAssignment(task.id, user.id).then(function(success) {
                task.status_name = 'Assigned';
                task.assigned_user_name = user.first_name + ' ' + user.last_name;

                $ioAlert.show('', 'The task was successfully assigned to ' +
                    task.assigned_user_name, 'success');

                if ($scope.fromMyQueues) {
                    $scope.backToQueues();
                } else if ($scope.fromQueueManager) {
                    $scope.backToQueueManager();
                } else if ($scope.fromWorkflowClient) {
                    $scope.backToWorkflowClient();
                } else if ($scope.fromOrders) {
                    $scope.backToOrder();
                } else if ($scope.fromLineItems) {
                    $scope.backToLineItem();
                } else if ($scope.fromFlights) {
                    $scope.backToFlight();
                } else {
                    $scope.backToTasks();
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            });
        }
    };

    var unassign = function(task) {
        if (task) {
            TaskService.unassign(task.id).then(function(success) {
                task.status_name = 'Unassigned';
                task.assigned_user_name = null;
                task.user_id = null;

                $scope.isAssigned = false;
                $scope.isOwner = false;

                $ioAlert.show('', 'The task was successfully unassigned', 'success');
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            });
        }
    };

    $scope.reAssign = function() {
        let task = $scope.taskAssignment;
        let clusterIds = [];

        if ($scope.task.reference_table == 'client') {
            // For client tasks, there is no order, so we have to get the cluster Ids from somewhere else.  Use the
            // cluster selector's.
            if ($scope.client && $scope.client.cluster_id) {
                clusterIds.push($scope.client.cluster_id);
            } else {
                // As a last resort...
                clusterIds = ClusterService.clusterIds;
            }
        } else {
            if ($scope.order === undefined || Object.entries($scope.order) == 0) {
                $ioAlert.show('Error!', 'Error getting order for current user', 'error');
                return;
            }
            clusterIds.push($scope.order.cluster_id[0]);
        }

        UserService.getUsersForQueue(task.queue_id, clusterIds).then(function(success) {
            UserService.users?.forEach((user) => {
                user.full_name = user.first_name + ' ' + user.last_name;
            });
            //modify object passed to modal service as needed
            let modalInstance = $modal.open(
                ModalService.returnModalType('reassignTask', {
                    data: {
                        items: UserService.users,
                        task: task
                    }
                })
            );
            modalInstance.result.then(function(selectedItem) {
                if (task.user_id && !selectedItem) {
                    unassign(task);
                } else if (selectedItem) {
                    assignToUser(task, selectedItem);
                }
            }, function() {});
        }, function(error) {
            console.log("Error getting users for queue");
        });
    };

    $scope.showTaskLogTimeModal = function() {
        var data = null;
        TaskService.taskAssignmentTimelog($scope.taskAssignment.id).then(function(success) {
            data = TaskService.Timelog;
            var modalInstance = $modal.open(
                ModalService.returnModalType('taskTimelog', {
                    data: {
                        items: TaskService.Timelog,
                        scope: $scope
                    }
                })
            );
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
        });

    };

    $scope.addToCalendar = function() {
        TaskService.addCalendarEvent($scope.taskAssignment.id).then(function(success) {
            if (success.data.authUrl) {
                $window.open(success.data.authUrl, '_self');
            } else if (success.data.calendarEvent) {
                $scope.hasCalendarEvent = true;
                $ioAlert.show('', CALENDAR_SUCCESS_MESSAGE, 'success');
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
        });
    };

    var assignToQueue = function(task, selectedQueue) {
        if (task && selectedQueue) {
            TaskService.updateTaskAssignmentQueue(task.id, selectedQueue.id).then(function(success) {
                task.queue_id = selectedQueue.id;
                if (success) {
                    $scope.currentQueue = success.queue;
                }
                $ioAlert.show('', 'The task was successfully assigned to queue id ' + selectedQueue.id, 'success');
            }, function(error) {
                $ioAlert.show('Error!', error, 'error');
            });
        }
    };

    $scope.campaignManagers = function() {
        var returnArray = [];
        for (var key in $scope.lineItems) {
            if ($scope.lineItems[key].campaign_manager_name) {
                returnArray.push($scope.lineItems[key].campaign_manager_name + ': Line Item #' + $scope.lineItems[key].id);
            }
        }
        return returnArray.slice(0, -1).join(', ') + returnArray.slice(-1);
    };

    // Change a tasks assigned queue
    $scope.changeQueue = function() {
        var task = $scope.taskAssignment;

        let clusterIds = [];
        if ($scope.task.reference_table == 'client') {
            if ($scope.client && $scope.client.cluster_id) {
                clusterIds.push($scope.client.cluster_id);
            } else {
                // As a last resort...
                clusterIds = ClusterService.clusterIds;
            }
        } else {
            if ($scope.order === undefined || Object.entries($scope.order) == 0) {
                $ioAlert.show('Error!', 'Error getting order for current user', 'error');
                return;
            }
            clusterIds.push($scope.order.cluster_id[0]);
        }

        QueuesService.getQueues(clusterIds).then(function(data) {
            var modalInstance = $modal.open(
                ModalService.returnModalType('assignQueue', {
                    data: {
                        items: QueuesService.queues
                    }
                })
            );

            modalInstance.result.then(function(selectedItem) {
                assignToQueue(task, selectedItem);
            }, function() {
                // Modal Dismissed. Do nothing.
            });
        }, function(error) {
            console.log("Error getting available queues for cluster " + clusterIds);
        });
    };

    // Increment task priority by one
    $scope.escalate = function() {
        var task = $scope.taskAssignment;
        if (task.priority < MAX_RPIORITY) {
            $scope.isBtnDisabled = true;
            TaskService.incrementTaskAssignmentPriority(task.id).then(function(data) {
                if (data.errors) {
                    $ioAlert.show('', data.errors[0], 'error');
                } else {
                    task.priority++;
                    $ioAlert.show('', 'Task priority escalated.', 'success');
                }
                $scope.isBtnDisabled = false;
            }, function(error) {
                $scope.isBtnDisabled = false;
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'Maximum priority level reached.', 'error');
        }
    };

    // Decrement task priority by one
    $scope.demote = function() {
        var task = $scope.taskAssignment;
        if (task.priority > MIN_PRIORITY) {
            $scope.isBtnDisabled = true;
            TaskService.decrementTaskAssignmentPriority(task.id).then(function(data) {
                if (data.errors) {
                    $ioAlert.show('', data.errors[0], 'error');
                } else {
                    task.priority--;
                    $ioAlert.show('', 'Task priority lowered.', 'success');
                }
                $scope.isBtnDisabled = false;
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                $scope.isBtnDisabled = false;
            });
        } else {
            $ioAlert.show('Error!', 'Minimum priority level reached.', 'error');
        }
    };

    $scope.completeTask = function() {
        TaskService.canCompleteTask($scope.taskAssignment.id).then(function (data) {
            if (data.canCompleteTask == 0) {
                $ioAlert.show('Error!', 'You are not allowed to complete this task because it is not assigned to you', 'error');
                return;
            }

            $scope.isAutoSubmission = true;

            function doCompleteTask(uploadFileIdx) {
                // We cannot actually complete the task until all file uploads, creative attach and deletes are completed,
                // else the workflow might be using invalid data (e.g. think there are no attached files, when they are
                // in fact being uploaded). So we wait for all such operations to complete before completing the task.
                // Every path followed by submitForm (called below) has to invoke this doCompleteTask method, and when
                // the last one is received, the $scope.uploadFileSet will be empty, and we will actually do the work.
                $scope.uploadFileSet.delete(uploadFileIdx);
                if ($scope.uploadFileSet.size == 0) {
                    let task = $scope.task;
                    let taskAssignment = $scope.taskAssignment;
                    if (task.time_tracking == '1' && task.time_tracking_required == '1' && (taskAssignment.logged_time == null || taskAssignment.logged_time == '0')) {
                        $ioAlert.show('Error!', 'This Task needs Work Time logged before it can be completed!', 'error');
                        $rs.loadingInProgress = false;
                    } else {
                        if ($scope.taskReqProcess !== true) {
                            $scope.taskReqProcess = true
                            TaskService.completeTaskAssignment($scope.taskAssignment.id).then(function () {
                                $rs.loadingInProgress = false;
                                $scope.taskReqProcess = false
                                if (TaskService.errors) {
                                    for (let x = 0; x < TaskService.errors.length; x++) {
                                        $ioAlert.show("Error", TaskService.errors[x], "error")
                                    }
                                    TaskService.errors = null
                                } else if ($scope.fromMyQueues) {
                                    $scope.backToQueues()
                                } else if ($scope.fromQueueManager) {
                                    $scope.backToQueueManager();
                                } else if ($scope.fromWorkflowClient) {
                                    $scope.backToWorkflowClient();
                                } else if ($scope.fromOrders) {
                                    $scope.backToOrder()
                                } else if ($scope.fromLineItems) {
                                    $scope.backToLineItem();
                                } else if ($scope.fromFlights) {
                                    $scope.backToFlight();
                                } else {
                                    $scope.backToTasks()
                                }
                            }, function () {
                                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                                $rs.loadingInProgress = false;
                            })
                        }
                    }
                }
            }

            $rs.loadertitle = "Processing task completion";
            $rs.loadingInProgress = true;
            $scope.uploadFileSet = new Set();
            $scope.submitForm($scope.formObj, doCompleteTask);
        }, function (error) {
            $rs.loadingInProgress = false;
            $ioAlert.show('Error!', JSON.stringify(error), 'error')
        })
    };

    $scope.followTask = function() {
        TaskService.followTaskAssignment($scope.taskAssignment.id).then(function(success) {
            $ioAlert.show('', 'You are now following this task.', 'success');
            $scope.isFollowed = true;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
        });
    };

    $scope.unfollowTask = function() {
        TaskService.unfollowTaskAssignment($scope.taskAssignment.id).then(function(success) {
            $ioAlert.show('', 'You are no longer following this task.', 'success');
            $scope.isFollowed = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
        });
    };

    $scope.showRejectConfirm = function() {
        $comments.open('lg', 'Are you sure you want to reject this task?')
            .then(function(formObj) {
                if (formObj) {
                    addComment($scope.taskAssignment.reference_table_row_id, formObj.comments);
                }
                rejectTask();
            }, function() {});
    };

    $scope.startTask = function() {
        if ($scope.taskReqProcess !== true) {
            $scope.taskReqProcess = true;
            TaskService.assignToCurrentUser($scope.taskAssignment.id).then(function(success) {
                $scope.taskReqProcess = false;
                getTaskAssignment();
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            });
        }
    };

    $scope.pushToVendor = function() {
        if ($scope.taskAssignment && $scope.task && ($scope.lineItem || $scope.order)) {
            // Process webhook events with the same user action for now
            if ($scope.task.event_names && $scope.task.vendor_name) {
                var entityName = null;
                var entityId = null;
                var eventNames = $scope.task.event_names;

                if ($scope.isOrderTask) {
                    entityName = 'order';
                    entityId = $scope.order.id;
                } else if ($scope.isLineItemTask) {
                    entityName = 'line_item';
                    entityId = $scope.lineItem.id;
                } else if ($scope.isFlightTask) {
                    entityName = 'flight';
                    entityId = $scope.flight.id;
                }

                TaskService.processWebhookEvents($scope.taskAssignment.id, entityName, entityId, eventNames).then(
                    function(success) {
                        if (TaskService.taskAssignment.status_id == STATUS_TASK_ASSIGNMENT_COMPLETE) {
                            if ($scope.fromMyQueues) {
                                $scope.backToQueues();
                            } else if ($scope.fromQueueManager) {
                                $scope.backToQueueManager();
                            } else if ($scope.fromWorkflowClient) {
                                $scope.backToWorkflowClient();
                            } else if ($scope.fromOrders) {
                                $scope.backToOrder();
                            } else if ($scope.fromLineItems) {
                                $scope.backToLineItem();
                            } else if ($scope.fromFlights) {
                                $scope.backToFlight();
                            } else {
                                $scope.backToTasks();
                            }
                        } else if (TaskService.taskAssignment.status_id == STATUS_TASK_ASSIGNMENT_FAILED) {
                            $ioAlert.show('', TaskService.taskAssignment.message, 'error');
                            updateComments($scope.task.reference_table);
                        }
                    },
                    function(error) {
                        console.log(error);
                    });
            } else if ($scope.task.vendor_name) {
                let lineItemId = null;
                let flightId = null;
                let clientId = null;

                if ($scope.isFlightTask) {
                    lineItemId = $scope.flight.line_item_id;
                    flightId = $scope.flight.id;
                } else if ($scope.isClientTask) {
                    clientId = $scope.client.id;
                } else {
                    lineItemId = $scope.lineItem.id;
                }

                TaskService.executeVendorPush($scope.taskAssignment.id, lineItemId,
                    $scope.task.vendor_name, flightId, clientId).then(function(success) {
                    if (TaskService.taskAssignment) {
                        if (TaskService.taskAssignment.status_id == STATUS_TASK_ASSIGNMENT_COMPLETE) {
                            if ($scope.fromMyQueues) {
                                $scope.backToQueues();
                            } else if ($scope.fromQueueManager) {
                                $scope.backToQueueManager();
                            } else if ($scope.fromWorkflowClient) {
                                $scope.backToWorkflowClient();
                            } else if ($scope.fromOrders) {
                                $scope.backToOrder();
                            } else if ($scope.fromLineItems) {
                                $scope.backToLineItem();
                            } else if ($scope.fromFlights) {
                                $scope.backToFlight();
                            } else {
                                $scope.backToTasks();
                            }
                        } else if (TaskService.taskAssignment.status_id == STATUS_TASK_ASSIGNMENT_FAILED) {
                            $ioAlert.show('', TaskService.taskAssignment.message, 'error');
                        }
                    }

                    getTaskAssignment();
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                });
            } else if ($scope.task.create_goal == 1) {
                TaskService.executeGoalPush($scope.taskAssignment.id, $scope.task.reference_table).then(function(success) {
                    if (success.taskAssignment.status_id == STATUS_TASK_ASSIGNMENT_COMPLETE) {
                        if ($scope.fromMyQueues) {
                            $scope.backToQueues();
                        } else if ($scope.fromQueueManager) {
                            $scope.backToQueueManager();
                        } else if ($scope.fromWorkflowClient) {
                            $scope.backToWorkflowClient();
                        } else if ($scope.fromOrders) {
                            $scope.backToOrder();
                        } else if ($scope.fromLineItems) {
                            $scope.backToLineItem();
                        } else if ($scope.fromFlights) {
                            $scope.backToFlight();
                        } else {
                            $scope.backToTasks();
                        }
                    } else if (success.taskAssignment.status_id == STATUS_TASK_ASSIGNMENT_FAILED) {
                        $ioAlert.show('', 'Push goal failed, to see the detals on the comment', 'error');
                        getTaskAssignment();
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong for pushing goal data.', 'error');
                });
            }
        } else {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
        }
    };

    $scope.logTimeForTask = function() {
        TaskService.logTimeForTask($scope.taskAssignment.id, $scope.loggedHours,
            $scope.loggedMinutes).then(function(success) {
            if (TaskService.Timelog) {
                if (TaskService.Timelog.status_id == STATUS_TASK_ASSIGNMENT_COMPLETE) {
                    if ($scope.fromMyQueues) {
                        $scope.backToQueues();
                    } else if ($scope.fromQueueManager) {
                        $scope.backToQueueManager();
                    } else if ($scope.fromWorkflowClient) {
                        $scope.backToWorkflowClient();
                    } else if ($scope.fromOrders) {
                        $scope.backToOrder();
                    } else if ($scope.fromLineItems) {
                        $scope.backToLineItem();
                    } else if ($scope.fromFlights) {
                        $scope.backToFlight();
                    } else {
                        $scope.backToTasks();
                    }
                } else if (TaskService.Timelog.status_id == STATUS_TASK_ASSIGNMENT_FAILED) {
                    $ioAlert.show('', TaskService.Timelog.message, 'error');
                }
            }

            getTaskAssignment();
            $ioAlert.show('', 'Time logged for Task.', 'success');

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
        });
    };

    $scope.saveCampaignManager = function() {
        if ($scope.isLineItemTask && $scope.lineItem) {
            OrdersService.addCampaignManager($scope.lineItem.id, $rs.userRole.id).then(function(success) {
                // todo: how to reload datatable without doing this
                $window.location.reload();
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            });
        }
    };

    $scope.openOrder = function() {
        $state.go('myTasksOrder', {
            taskId: $scope.taskAssignment.id,
            id: $scope.taskAssignment.reference_table_row_id,
            taskDetail: true
        });
    };

    $scope.backToWorkflowClient = function() {
        $state.go('viewWorkflowClient', {
            id: $stateParams.clientId
        });
    };

    $scope.backToOrder = function() {
        if ($stateParams.fromPage && $stateParams.fromPage == 'lineitem' && parseInt($scope.taskAssignment.line_item_id)) {
            $state.go('viewLineItem', {
                'lineItemId': parseInt($scope.taskAssignment.line_item_id)
            });
        } else if ($stateParams.fromPage && $stateParams.fromPage == 'detailedOrders') {
            $state.go('detailedOrders');
        } else if ($stateParams.orderId) {
            $state.go('viewOrder', {
                id: $stateParams.orderId
            });
        };
    };

    $scope.backToLineItem = function() {
        $state.go('viewLineItem', {
            'lineItemId': (parseInt($scope.taskAssignment.line_item_id))
        });
    };

    $scope.backToFlight = function() {
        $state.go('viewLineItem', {
            lineItemId: $scope.lineItemId,
            flightId: $stateParams.flightId
        });
    };

    $scope.backToTasks = function() {
        if (!$scope.IS_WRAPPER_ENABLED) {
            $state.go('myTasks');
        }
    };

    $scope.backToQueues = function() {
        if (!$scope.IS_WRAPPER_ENABLED) {
            $state.go('myQueues', {
                "queueId": $stateParams.myQueues
            });
        }
    };

    $scope.backToQueueManager = function() {
        if (!$scope.IS_WRAPPER_ENABLED) {
            $state.go('queueManager');
        }
    };

    var displayLineItemTaskDetails = function() {
        if ($scope.formFields && $scope.lineItem) {
            $scope.lineItemTaskDetails = [];

            for (var i = 0; i < $scope.formFields.length; i++) {
                var field = $scope.formFields[i];

                if ($scope.lineItem.hasOwnProperty(field.field_name)) {
                    var displayPair = {};

                    if (field.lookup_content) {
                        for (var x = 0; x < field.lookup_content.length; x++) {
                            var content = field.lookup_content[x];

                            if (content.id == $scope.lineItem[field.field_name]) {
                                displayPair[field.display_name] = content.lookup_value;
                            }
                        }
                    } else {
                        displayPair[field.display_name] = $scope.lineItem[field.field_name];
                    }
                    $scope.lineItemTaskDetails.push(displayPair);
                }
            }
        }
    };

    var loadForm = function(taskId) {
        // Wait for both the creatives and the entity (client, order, lineitem, or flight) before loading the form.
        if (taskId != null && $scope.creativesReceived && $scope.entityReceived) {
            $scope.creativesReceived = false;
            $scope.entityReceived = false;
            doLoadForm(taskId);
        }
    }

    let doLoadForm = function(taskId) {
        FormService.getTaskFormFieldGroups(taskId).then(function(fieldGroups) {
            var formFieldGroups = [];
            if (fieldGroups) {
                formFieldGroups = fieldGroups;
            }

            let clusterId;
            if ($scope.isClientTask) {
                clusterId = $scope.client.cluster_id;
            } else {
                clusterId = $scope.order.cluster_id[0];
            }
            $rs.$broadcast('fetchTaggingUsers', clusterId); // Ability to tag users in comments, with @
            FormService.getTaskFormFields(taskId, clusterId, true).then(function(success) {
                $scope.formFields = FormService.formFields;

                if (!$scope.formFields) {
                    $scope.formFields = [];
                }

                buildSchema($scope.formFields);
                buildForm(formFieldGroups, $scope.formFields);
                FormService.registerForDateChanges($scope.form, $scope.formFields, $scope.model);

                // todo: hold off on this for now...
                // only applicable if there are form fields
                // displayLineItemTaskDetails();
            }, function(error) {
                console.log("error loading form fields for task: " + taskId);
            });
        }, function(error) {
            console.log("error loading form field groups for task: " + taskId);
        });
    };

    // Dynamic form schema
    var buildSchema = function(formFields) {
        let entityData;
        if ($scope.isLineItemTask) {
            entityData = angular.copy($scope.lineItem);
        } else if ($scope.isOrderTask) {
            entityData = angular.copy($scope.order);
        } else if ($scope.isClientTask) {
            entityData = angular.copy($scope.client);
        } else if ($scope.isFlightTask) {
            entityData = angular.copy($scope.flight);
        }
        // Pass in an empty array as realCreativeFilenames, otherwise it won't update any required creative field to
        // make it non-required if appropriate.
        FormService.buildDynamicFormSchema($scope.schema, $scope.formFieldMap, formFields, false, entityData, $scope.creatives, [], false);
        FormService.addCommentSchema($scope.schema);

        var editArray = [];
        for (var x in $scope.schema.properties) {
            if ($scope.schema.properties.hasOwnProperty(x)) {
                editArray.push({
                    "prop": x,
                    "type": $scope.schema.properties[x].type
                });
            }
        }

        updateForm(entityData, editArray);
    };

    // Dynamic form structure
    var buildForm = function(formFieldGroups, formFields) {
        let clientId = null;
        if ($scope.order && $scope.order.client_id) {
            clientId = $scope.order.client_id[0];
        } else if ($scope.client) {
            clientId = $scope.client.id;
        }
        let cluster_id = null;
        if ($scope.order && $scope.order.cluster_id) {
            cluster_id = $scope.order.cluster_id[0];
        }
        FormService.buildDynamicForm($scope.model, $scope.entireForm, $scope.formParentChildInfo, $scope.schema, $scope.formFieldMap,
            formFieldGroups, formFields, false, clientId, undefined, undefined, $rs.userRole,'task');
        _.each($scope.entireForm, function (section) {
            if (section.type == 'hidden') {
                return;
            }
            $scope.form.push(section);
        });
        $scope.form.push(FormService.getSubmitControl("Save Details", "formObj"));
        if (!$scope.user_is_vendor) {
            $scope.form.push(FormService.getCommentInputSection('myTasksView', false, cluster_id));
        }
    };

    var updateForm = function(dataSource, editArray) {
        let entityData = angular.copy(dataSource);
        _.each(editArray, function(edit) {
            const field_name = edit.prop;
            switch (edit.type) {
                case 'boolean':
                    if (entityData.hasOwnProperty(field_name)) {
                        entityData[field_name] = entityData[field_name] == 1;
                    }
                    break;
                case 'array':
                    let selectArr = [];
                    if (entityData.hasOwnProperty(field_name)) {
                        const arrlen = entityData[field_name].length;
                        if (arrlen == 2 && typeof entityData[field_name][1] == 'string') {
                            selectArr.push(entityData[field_name][1]);
                        } else {
                            for (let k = 0; k < arrlen; k++) {
                                if (entityData[field_name][k] && entityData[field_name][k].length == 1) {
                                    selectArr.push(String(entityData[field_name][k][0]).replace("CUST_", ""));
                                } else if (entityData[field_name][k]) {
                                    selectArr.push(entityData[field_name][k][1]);
                                }
                            }
                        }
                        entityData[field_name] = selectArr;
                    } else {
                        // if entity data does not have the attribute for multi-select
                        // field, we need to set its value to empty array [] instead of
                        // undefined value as default
                        entityData[field_name] = selectArr;
                    }
                break;
            case 'string':
                if (entityData.hasOwnProperty(field_name)) {
                    if (typeof entityData[field_name] == 'object') {
                        entityData[field_name] = entityData[field_name][1];
                    }
                }
                break;
            }
        });
        $scope.model = entityData;
    };

    $scope.submitForm = function(formObj, callback = null) {
        let returnObj = FormService.validateCustomWidgets($scope.formFields, $scope.model);
        let isFormWidgetsValid = !returnObj.validateWidgets.includes(false);
        let dayPartingValidation = FormService.validateDayPartingWidget($scope.formFields, $scope.model);
        $scope.model = returnObj.model;
        $scope.$broadcast('schemaFormValidate');
        if (formObj.$valid && returnObj.isValid && isFormWidgetsValid && dayPartingValidation) {
            //var taskData = harvestFormData($scope.model);
            let taskData = FormService.harvestData($scope.formFields, $scope.form, $scope.model, 'tasks', $scope.formParentChildInfo);
            taskData.taskAssignmentId = $scope.taskAssignment.id;
            if ($scope.isLineItemTask) {
                taskData.lineItemId = $scope.taskAssignment.reference_table_row_id;
            } else if ($scope.isOrderTask) {
                taskData.taskId = $scope.taskAssignment.task_id;
                taskData.orderId = $scope.order.id;
            } else if ($scope.isClientTask) {
                taskData.clientId = $scope.client.id;
            } else if ($scope.isFlightTask) {
                taskData.flightId = $scope.flight.id;
            }
            $scope.submitTaskData = true;
            if ($scope.model && $scope.model.comment) {
                addComment($scope.taskAssignment.reference_table_row_id, $scope.model.comment);
            }
            let customFilePresent = false;
            _.each($scope.model, function(itemVal, prop){
                let fieldObj = _.find($scope.formFields, {field_name: prop});
                if (fieldObj && fieldObj.input_type == 'file' && $scope.model[prop]) {
                    if ($scope.isLineItemTask) {
                        let adGroupMoreInfo = {
                            lineItemId: $scope.lineItem.id,
                            fieldId: fieldObj.id,
                            fieldType: fieldObj.input_type,
                            entityType: 'line_item_task',
                            taskAssignmentId: $scope.taskAssignment.id,
                        };

                        let fileObjs = getUploadingFilesAndRemovedFiles($scope.model[prop], prop, $scope.form, adGroupMoreInfo);
                        deleteLineItemCreativeAssets($scope.lineItem.id, fileObjs['removed'], adGroupMoreInfo, callback);
                        addLineItemCreativeAssets($scope.lineItem.id, fileObjs['uploading'], false, adGroupMoreInfo, callback);
                    } else if ($scope.isOrderTask) {
                        let adGroupMoreInfo = {
                            orderId: $scope.order.id,
                            fieldId: fieldObj.id,
                            fieldType: fieldObj.input_type,
                            entityType: 'order_task',
                            taskId: $scope.taskAssignment.task_id,
                            taskAssignmentId: $scope.taskAssignment.id,
                        };
                        let fileObjs = getUploadingFilesAndRemovedFiles($scope.model[prop], prop, $scope.form, adGroupMoreInfo);
                        deleteOrderCreativeAssets($scope.order.id, fileObjs['removed'], adGroupMoreInfo, callback);
                        addOrderCreativeAssets($scope.order.id, fileObjs['uploading'], false, adGroupMoreInfo, callback);
                    } else if ($scope.isFlightTask) {
                        let adGroupMoreInfo = {
                            flightId: $scope.flight.id,
                            fieldId: fieldObj.id,
                            fieldType: fieldObj.input_type,
                            entityType: 'flight_task',
                            taskAssignmentId: $scope.taskAssignment.id,
                        };
                        let fileObjs = getUploadingFilesAndRemovedFiles($scope.model[prop], prop, $scope.form, adGroupMoreInfo);
                        deleteFlightCreativeAssets($scope.flight.id, fileObjs['removed'], adGroupMoreInfo, callback);
                        addFlightCreativeAssets($scope.flight.id, fileObjs['uploading'], false, adGroupMoreInfo, callback);
                    } else if ($scope.isClientTask) {
                        addClientCreativeAssets($scope.client.id, $scope.model[prop], false, callback)
                    }
                } else if (fieldObj && ['creative', 'facebook-create-ads'].includes(fieldObj.input_type) && $scope.model[prop]) {
                    if ($scope.isLineItemTask) {
                        if ($scope.model[prop].media) {
                            addLineItemCreativeAssets($scope.lineItem.id, $scope.model[prop].media, $scope.model[prop].library, null, callback);
                        }else if ($scope.model[prop].selectedImages && $scope.model[prop].selectedImages.length > 0) {
                            attachCreatives($scope.lineItem.id, $scope.model[prop].selectedImages, 'lineItem', callback);
                            if ($scope.model[prop].thirdPartyCreatives && $scope.model[prop].thirdPartyCreatives.length > 0) {
                                attachCreatives($scope.lineItem.id, $scope.model[prop].thirdPartyCreatives, 'lineItem', callback);
                            }
                        }
                    } else if ($scope.isOrderTask) {
                        if ($scope.model[prop].media) {
                            addOrderCreativeAssets($scope.order.id, $scope.model[prop].media, $scope.model[prop].library, callback);
                        }else if ($scope.model[prop].selectedImages && $scope.model[prop].selectedImages.length > 0) {
                            attachCreatives($scope.order.id, $scope.model[prop].selectedImages, 'order', callback);
                            if ($scope.model[prop].thirdPartyCreatives && $scope.model[prop].thirdPartyCreatives.length > 0) {
                                attachCreatives($scope.order.id, $scope.model[prop].thirdPartyCreatives, 'order', callback);
                            }
                        }
                    } else if ($scope.isFlightTask) {
                        if ($scope.model[prop].media) {
                            addFlightCreativeAssets($scope.flight.id, $scope.model[prop].media, $scope.model[prop].library, null, callback);
                        }else if ($scope.model[prop].selectedImages && $scope.model[prop].selectedImages.length > 0) {
                            attachCreatives($scope.flight.id, $scope.model[prop].selectedImages, 'flight', callback);
                            if ($scope.model[prop].thirdPartyCreatives && $scope.model[prop].thirdPartyCreatives.length > 0) {
                                attachCreatives($scope.flight.id, $scope.model[prop].thirdPartyCreatives, 'flight', callback);
                            }
                        }
                    } else if ($scope.isClientTask) {
                        if ($scope.model[prop].media) {
                            addClientCreativeAssets($scope.client.id, $scope.model[prop].media, $scope.model[prop].library, callback);
                        }
                        // No need to invoke attachCreatives here because client creatives do not have a tbl__tapio_creative_xref
                        // entry (which is that attachCreatives handles).
                    }
                } else if (fieldObj && fieldObj.input_type == "custom_file" && $scope.model[prop]) {
                    customFilePresent = true;
                    $scope.uploadCustomFile(prop, callback);
                }
            });
            if ($scope.isLineItemTask && $scope.submitTaskData) {
                addLineItemTaskAttributes(taskData, callback);
                $scope.submitTaskData = false;
            } else if ($scope.isOrderTask && $scope.submitTaskData) {
                addOrderTaskAttributes(taskData, callback);
                $scope.submitTaskData = false;
            } else if ($scope.isFlightTask && $scope.submitTaskData) {
                addFlightTaskAttributes(taskData, callback);
                $scope.submitTaskData = false;
            } else if ($scope.isClientTask && $scope.submitTaskData) {
                addClientTaskAttributes(taskData, callback);
                $scope.submitTaskData = false;
            }

            // Refresh the form for calculated fields (if there's a custom file present, it will refresh once dealt with).
            if (!callback && !customFilePresent) {
                const calculation_types = ['calculated', 'calculated-override'];
                const calculated_field = $scope.formFields.find(field => calculation_types.includes(field.input_type));
                if (calculated_field) {
                    getTaskAssignment();
                }
            }
            return true;
        } else if(!dayPartingValidation){
            $rs.loadingInProgress = false;
            $ioAlert.show("Validation Error!", "Please check the day parting time slots", "error");
        } else {
            $rs.loadingInProgress = false;
            $ioAlert.show("Validation Error!", "Please fill in the required fields", 'error');
            return false;
        }
    };

    $scope.uploadCustomFile = function(prop, callback) {
        let entityName = null;
        let entityId = null;

        if ($scope.isLineItemTask) {
            entityName = 'line_item';
            entityId = $scope.taskAssignment.reference_table_row_id;
        } else if ($scope.isOrderTask) {
            entityName = 'order';
            entityId = $scope.order.id;
        } else if ($scope.isFlightTask) {
            entityName = 'flight';
            entityId = $scope.flight.id;
        }

        if (entityName && entityId) {
            const uploadFileIdx = $scope.uploadFileSetIndex++;
            $scope.uploadFileSet.add(uploadFileIdx);
            FormService.processCustomFile(entityName, entityId, prop, $scope.model[prop], $scope.taskAssignment.id).then(function() {
                if (callback) {
                    callback(uploadFileIdx);
                } else {
                    // Refresh form
                    getTaskAssignment();
                }
            }, function() {
                // Here we voluntarily avoid calling the callback, so that the task won't complete if there's an error.
                if (!callback) {
                    getTaskAssignment();
                }
            });
        }
    };

    var addLineItemTaskAttributes = function(taskAttributeData, callback) {
        if ($scope.isSharedTask && _.size($scope.lineItems) > 1) {
            _.each($scope.lineItems, function(lineItem) {
                let attributeData = Object.assign({}, taskAttributeData);
                attributeData.lineItemId = lineItem.id;
                addLineItemTaskAttribute(attributeData, callback);
            });
        } else {
            addLineItemTaskAttribute(taskAttributeData, callback);
        }
    };

    var addLineItemTaskAttribute = function(taskAttributeData, callback = null) {
        // For historical reasons, variables are called uploadFile something, but we use the same set for non-file
        // related updates.
        const uploadFileIdx = $scope.uploadFileSetIndex++;
        $scope.uploadFileSet.add(uploadFileIdx);
        OrdersService.addLineItemTaskAttributes(taskAttributeData).then(function(success) {
            if (callback) {
                callback(uploadFileIdx);
            }
            $scope.lineItem = OrdersService.lineItem;
            if ($scope.task.enable_comment_snapshot == 1) {
                updateComments('line_item');
            }
            $ioAlert.show('', 'LineItem task saved successfully', 'success');
        }, function(response) {
            // Here we voluntarily avoid calling the callback, so that the task won't complete if there's an error.
            if (response.errors) {
                _.each(response.errors, function(error){
                    $ioAlert.show('Error!', error, 'error');
                });
            } else {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            }
        });
    };

    var addOrderTaskAttributes = function(taskAttributeData, callback = null) {
        const uploadFileIdx = $scope.uploadFileSetIndex++;
        $scope.uploadFileSet.add(uploadFileIdx);
        OrdersService.addOrderTaskAttributes(taskAttributeData).then(function(success) {
            if (callback) {
                callback(uploadFileIdx);
            }
            $scope.order = OrdersService.order;
            if ($scope.task.enable_comment_snapshot == 1) {
                updateComments('order');
            }
            $ioAlert.show('', 'Order task saved successfully', 'success');
        }, function(response) {
            // Here we voluntarily avoid calling the callback, so that the task won't complete if there's an error.
            if(response.errors){
                _.each(response.errors, function(error){
                    $ioAlert.show('Error!', error, 'error');
                });
            }else{
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            }
        });
    };

    let addFlightTaskAttributes = function(taskAttributeData, callback = null) {
        const uploadFileIdx = $scope.uploadFileSetIndex++;
        $scope.uploadFileSet.add(uploadFileIdx);
        OrdersService.addFlightTaskAttributes(taskAttributeData).then(function(success) {
            if (callback) {
                callback(uploadFileIdx);
            }
            $scope.flight = OrdersService.flight;
            if ($scope.task.enable_comment_snapshot == 1) {
                updateComments('flight');
            }
            $ioAlert.show('', 'Flight task saved successfully', 'success');
        }, function(response) {
            // Here we voluntarily avoid calling the callback, so that the task won't complete if there's an error.
            if (response.errors) {
                _.each(response.errors, function(error){
                    $ioAlert.show('Error!', error, 'error');
                });
            } else {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            }
        });
    };

    let addClientTaskAttributes = function(taskAttributeData, callback = null) {
        const uploadFileIdx = $scope.uploadFileSetIndex++;
        $scope.uploadFileSet.add(uploadFileIdx);
        OrdersService.addClientTaskAttributes(taskAttributeData).then(function(success) {
            if (callback) {
                callback(uploadFileIdx);
            }
            $scope.client = OrdersService.client;
            if ($scope.task.enable_comment_snapshot == 1) {
                updateComments('client');
            }
            $ioAlert.show('', 'Client task saved successfully', 'success');
        }, function(response) {
            // Here we voluntarily avoid calling the callback, so that the task won't complete if there's an error.
            if (response.errors) {
                _.each(response.errors, function(error){
                    $ioAlert.show('Error!', error, 'error');
                });
            } else {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            }
        });
    };

    var updateComments = function(entityType) {
        switch (entityType) {
            case 'line_item':
                getLineItemComments();
                break;
            case 'order':
                getOrderComments();
                break;
            case 'flight':
                getFlightComments();
                break;
            case 'client':
                getClientComments();
                break;
        }
    }

    const addComment = function(id, commentText) {
        let entityType = '';
        entityType = $scope.isLineItemTask ? 'line_item' : entityType;
        entityType = $scope.isOrderTask ? 'order' : entityType;
        entityType = $scope.isFlightTask ? 'flight' : entityType;
        entityType = $scope.isClientTask ? 'client' : entityType;

        CommentService.addComment(entityType, id, commentText, false, false,
            null, $scope.taskAssignment.id).then(function(success) {
            updateComments(entityType);
            $scope.model.comment = null;
        }, function(error) {
            console.log("Error saving comment for " + entityType + " " + id);
        });
    };

    const updateOrderTaskFileFields = function(moreInfo) {
        if (moreInfo.fieldId) {
            const orderTaskAttrObj = {
                orderId: moreInfo.orderId,
                formFieldId: moreInfo.fieldId,
                taskId: moreInfo.taskId,
                taskAssignmentId: moreInfo.taskAssignmentId,
            }
            OrdersService.getOrderTaskFileFieldAttrs(orderTaskAttrObj).then(function(fieldInfo) {
                if(!fieldInfo.attr_value) {
                    return;
                }
                _.each($scope.form, function(form) {
                    _.each(form.items, function(item) {
                        if(item.field_name == fieldInfo.field_name) {
                            item.fileObjList = fieldInfo.attr_value;
                        }
                    });
                });
            }, function() {
                $ioAlert.show("Error!", "An error occurred updating the order task field info.", 'error');
            });
        }
    }

    const updateLineItemTaskFileFields = function(moreInfo) {
        if(moreInfo.fieldId){
            var lineItemTaskAttrObj = {
                lineItemId: moreInfo.lineItemId,
                formFieldId: moreInfo.fieldId,
                taskAssignmentId: moreInfo.taskAssignmentId,
            }
            OrdersService.getLineItemTaskFileFieldAttrs(lineItemTaskAttrObj).then(function(fieldInfo) {
                if(!fieldInfo.attr_value) {
                    return;
                }
                _.each($scope.form, function(form) {
                    _.each(form.items, function(item) {
                        if(item.field_name == fieldInfo.field_name) {
                            item.fileObjList = fieldInfo.attr_value;
                            // Correct the form model values
                            let modelValues = [];
                            fieldInfo.attr_value.forEach((file) => {
                                modelValues.push({name: file.file_name});
                            });
                            $scope.model[fieldInfo.field_name] = modelValues;
                        }
                    });
                });
            }, function() {
                $ioAlert.show("Error!", "An error occurred updating the line item task field info.", 'error');
            });
        }
    }

    let updateFlightTaskFileFields = function(moreInfo) {
        if (moreInfo.fieldId) {
            let flightTaskAttrObj = {
                flightId: moreInfo.flightId,
                formFieldId: moreInfo.fieldId,
                taskAssignmentId: moreInfo.taskAssignmentId,
            }
            OrdersService.getFlightTaskFileFieldAttrs(flightTaskAttrObj).then(function(fieldInfo) {
                if (!fieldInfo.attr_value) {
                    return;
                }
                _.each($scope.form, function(form) {
                    _.each(form.items, function(item) {
                        if (item.field_name == fieldInfo.field_name) {
                            item.fileObjList = fieldInfo.attr_value;
                        }
                    });
                });
            }, function() {
                $ioAlert.show("Error!", "An error occurred updating the flight task field info.", 'error');
            });
        }
    }

    const orderTaskFileUpload = function(moreInfo, successObj, callback, uploadFileIdx) {
        if(moreInfo.fieldId){
            const orderTaskAttrObj = {
                orderId: moreInfo.orderId,
                formFieldId: moreInfo.fieldId,
                attrValue: successObj.id,
                taskAssignmentId: moreInfo.taskAssignmentId,
            }
            OrdersService.addOrderTaskAttribute(orderTaskAttrObj).then(function(response) {
                if (callback) {
                    callback(uploadFileIdx);
                }
                updateOrderTaskFileFields(moreInfo);
            }, function() {
                if (callback) {
                    callback(uploadFileIdx);
                }
                $ioAlert.show("Error!", "An error occurred adding the order task attr.", 'error');
            });
        }
    };

    const lineItemTaskFileUpload = function(moreInfo, successObj, callback, uploadFileIdx) {
        if(moreInfo.fieldId){
            var lineItemTaskAttrObj = {
                lineItemId: moreInfo.lineItemId,
                formFieldId: moreInfo.fieldId,
                taskAssignmentId: moreInfo.taskAssignmentId,
                attrValue: successObj.id,
            }
            OrdersService.addNewLineItemTaskAttributes(lineItemTaskAttrObj).then(function(response) {
                if (callback) {
                    callback(uploadFileIdx);
                }
                updateLineItemTaskFileFields(moreInfo);
            }, function() {
                if (callback) {
                    callback(uploadFileIdx);
                }
                $ioAlert.show("Error!", "An error occurred adding the line item task attr.", 'error');
            });
        }
    };

    let flightTaskFileUpload = function(moreInfo, successObj, callback, uploadFileIdx) {
        if (moreInfo.fieldId) {
            let flightTaskAttrObj = {
                flightId: moreInfo.flightId,
                formFieldId: moreInfo.fieldId,
                taskAssignmentId: moreInfo.taskAssignmentId,
                attrValue: successObj.id,
            }
            OrdersService.addNewFlightTaskAttributes(flightTaskAttrObj).then(function(response) {
                if (callback) {
                    callback(uploadFileIdx);
                }
                updateFlightTaskFileFields(moreInfo);
            }, function() {
                if (callback) {
                    callback(uploadFileIdx);
                }
                $ioAlert.show("Error!", "An error occurred adding the flight task attr.", 'error');
            });
        }
    };

    $rs.$$listeners['tasksUploadSuccess'] = [];
    $rs.$$listenerCount['tasksUploadSuccess'] = 0;
    $rs.$on('tasksUploadSuccess', function(event, successObj, additionalParams) {
        getCreatives();
        let moreInfo = additionalParams.adGroupMoreInfo;
        if(!moreInfo) {
            if (additionalParams.callback) {
                additionalParams.callback(additionalParams.uploadFileIdx);
            }
            return;
        }
        switch (moreInfo.entityType) {
            case 'order_task':
                orderTaskFileUpload(moreInfo, successObj, additionalParams.callback, additionalParams.uploadFileIdx);
                break;
            case 'line_item_task':
                lineItemTaskFileUpload(moreInfo, successObj, additionalParams.callback, additionalParams.uploadFileIdx);
                break;
            case 'flight_task':
                flightTaskFileUpload(moreInfo, successObj, additionalParams.callback, additionalParams.uploadFileIdx);
                break;
            default:
                if (additionalParams.callback) {
                    additionalParams.callback(additionalParams.uploadFileIdx);
                }
                break;
        }
    });

    const getUploadingFilesAndRemovedFiles = function(newFileObjList, fieldName, form, adGroupMoreInfo) {
        let oldFileObjList = [];
        form.forEach((f) =>{
            if (f.items) {
                let fileField = _.find(f.items, {field_name: fieldName});
                if(fileField) {
                    oldFileObjList = fileField.fileObjList ? fileField.fileObjList : [];
                    return;
                }
            }
        });

        let uploadingFileObjs = newFileObjList;
        let deleteFileObjs = [];
        if(oldFileObjList && oldFileObjList.length > 0) {
            // newFileObjList is the file list on the form
            // oldFileObjList is the file list from database
            // uploadingFileObjs will keep the new files the user added
            // deleteFiles will keep the files the user removed
            // We remove the duplicated files between 2 arrays to avoid duplicated file uploading
            // newFileObjList structure [{ name: val }, { name: val }]
            // oldListObjList structure [{ attr_id: val, file_name: val}, {attr_id: val, file_name: val}]
            let newListSet = new Set(newFileObjList.map(({ name }) => name));
            let oldListSet = new Set(oldFileObjList.map(({file_name}) => file_name));
            uploadingFileObjs = newFileObjList.filter(({ name }) => !oldListSet.has( name ));
            deleteFileObjs = oldFileObjList.filter(({file_name}) => !newListSet.has(file_name));
        }
        return {'uploading': uploadingFileObjs, 'removed': deleteFileObjs};
    }

    const addLineItemCreativeAssets = function(lineItemId, creativeFiles, addToLibrary, adGroupMoreInfo, callback) {
        let libraryCreative = "no";
        if (addToLibrary) {
            libraryCreative = "yes";
        }
        if (creativeFiles.length) {
            $ioAlert.show('',
                'Creatives are being uploaded, please don’t refresh the page. You can check the status in the notifications tab',
                'success');
        }
        angular.forEach(creativeFiles, function(file) {
            // In case, we send the file which file size is undefined to the function 'file uploading'
            if (!file.size) {
                $ioAlert.show('Error!', 'The file size of the file (' + file.name + ') is undefined', 'error');
                console.log(file);
                return;
            }
            const uploadFileIdx = $scope.uploadFileSetIndex++;
            // Here we add a value to uploadFileSet, but we do not invoke the callback method here, because we'll do another
            // backend query after getting the image signature and uploading the file.
            // The reason we're adding a value to the set early, then, is to prevent another file or backend query
            // from causing us to think we are done with all the uploads. Processing resumes when the broadcast response
            // (e.g. 'tasksUploadSuccess') is received.
            $scope.uploadFileSet.add(uploadFileIdx);
            CreativeServicePro.getImgSignature({
                lineItemId: lineItemId,
                fileName: file.name
            }).then(function(success) {
                const additionalParams = {
                    "from": "lineItem",
                    "lineItemId": lineItemId,
                    "libraryCreative": libraryCreative,
                    "file_name": file.name,
                    "file_size": file.size,
                    "isTasksPage": true,
                    "sharedTask": $scope.taskAssignment.shared,
                    "uploadFileIdx": uploadFileIdx,
                    "callback": callback,
                };
                if(adGroupMoreInfo){
                    additionalParams.adGroupMoreInfo = adGroupMoreInfo;
                }
                $rs.$broadcast('cloudinaryImageUpload', success, file, additionalParams);
            }, function(error) {
                if (callback) {
                    callback(uploadFileIdx)
                };
                const details = JSON.stringify(error);
                $ioAlert.show('Error!', 'Could not get img signature.' + details, 'error');
                console.log(error);
            });
        });
    };

    const deleteOrderCreativeAssets = function(orderId, creativeFileObjs, adGroupMoreInfo, callback) {
        let orderTaskAttrIds = [];
        _.each(creativeFileObjs, function(fileObj){
            orderTaskAttrIds.push(fileObj.attr_id);
        });
        let params = {
            'orderTaskAttrIds': orderTaskAttrIds.toString(),
            'taskAssignmentId': adGroupMoreInfo.taskAssignmentId,
        }
        if(orderTaskAttrIds.length > 0) {
            const uploadFileIdx = $scope.uploadFileSetIndex++;
            $scope.uploadFileSet.add(uploadFileIdx);
            OrdersService.removeOrderTaskFileAttrsAndCreatives(params).then(function(response) {
                updateOrderTaskFileFields(adGroupMoreInfo);
                if (callback) {
                    callback(uploadFileIdx);
                }
                $ioAlert.show("", "File was removed successfully.", 'success');
            }, function() {
                if (callback) {
                    callback(uploadFileIdx)
                };
                $ioAlert.show("Error!", "An error occurred deleting the order task attrs.", 'error');
            });
        }
    };

    const deleteLineItemCreativeAssets = function(lineItemId, creativeFileObjs, adGroupMoreInfo, callback) {
        let lineItemTaskAttrIds = [];
        _.each(creativeFileObjs, function(fileObj){
            lineItemTaskAttrIds.push(fileObj.attr_id);
        });
        let params = {
            'lineItemTaskAttrIds': lineItemTaskAttrIds.toString(),
        }
        if(lineItemTaskAttrIds.length > 0) {
            const uploadFileIdx = $scope.uploadFileSetIndex++;
            $scope.uploadFileSet.add(uploadFileIdx);
            OrdersService.removeLineItemTaskFileAttrsAndCreatives(params).then(function(response) {
                updateLineItemTaskFileFields(adGroupMoreInfo);
                if (callback) {
                    callback(uploadFileIdx);
                }
                $ioAlert.show("", "File was removed successfully.", 'success');
            }, function() {
                if (callback) {
                    callback(uploadFileIdx)
                };
                $ioAlert.show("Error!", "An error occurred deleting the line item task attrs.", 'error');
            });
        }
    };

    const deleteFlightCreativeAssets = function(flightId, creativeFileObjs, adGroupMoreInfo, callback) {
        let flightTaskAttrIds = [];
        _.each(creativeFileObjs, function(fileObj){
            flightTaskAttrIds.push(fileObj.attr_id);
        });
        let params = {
            'flightTaskAttrIds': flightTaskAttrIds.toString(),
        }
        if(flightTaskAttrIds.length > 0) {
            const uploadFileIdx = $scope.uploadFileSetIndex++;
            $scope.uploadFileSet.add(uploadFileIdx);
            OrdersService.removeFlightTaskFileAttrsAndCreatives(params).then(function(response) {
                updateFlightTaskFileFields(adGroupMoreInfo);
                if (callback) {
                    callback(uploadFileIdx);
                }
                $ioAlert.show("", "File was removed successfully.", 'success');
            }, function(error) {
                if (callback) {
                    callback(uploadFileIdx);
                }
                $ioAlert.show("Error!", "An error occurred deleting the flight task attrs." + JSON.stringify(error), 'error');
            });
        }
    };

    const addOrderCreativeAssets = function(orderId, creativeFiles, addToLibrary, adGroupMoreInfo, callback) {
        let libraryCreative = "no";
        if (addToLibrary) {
            libraryCreative = "yes"
        }
        if (creativeFiles.length) {
            $ioAlert.show('', 'Creatives are being uploaded dont refresh the page. You can check the status in the notifications tab', 'success');
        }
        angular.forEach(creativeFiles, function(file) {
            const uploadFileIdx = $scope.uploadFileSetIndex++;
            $scope.uploadFileSet.add(uploadFileIdx);
            CreativeServicePro.getImgSignature({
                orderId: orderId,
                fileName: file.name
            }).then(function(success) {
                const additionalParams = {
                    "from": "order",
                    "orderId": orderId,
                    "libraryCreative": libraryCreative,
                    "file_name": file.name,
                    "file_size": file.size,
                    "isTasksPage": true,
                    "uploadFileIdx": uploadFileIdx,
                    "callback": callback,
                };
                if(adGroupMoreInfo){
                    additionalParams.adGroupMoreInfo = adGroupMoreInfo;
                }
                $rs.$broadcast('cloudinaryImageUpload', success, file, additionalParams);
            }, function(error) {
                if (callback) {
                    callback(uploadFileIdx);
                }
                const details = JSON.stringify(error);
                $ioAlert.show('Error!', 'Could not get img signature.' + details, 'error');
                console.log(error);
            });

        });
    };

    const addFlightCreativeAssets = function(flightId, creativeFiles, addToLibrary, adGroupMoreInfo, callback) {
        let libraryCreative = "no";
        if (addToLibrary) {
            libraryCreative = "yes"
        }
        if (creativeFiles.length) {
            $ioAlert.show(
                '',
                "Creatives are being uploaded, please don't refresh the page. You can check the status in the notifications tab",
                'success'
            );
        }
        angular.forEach(creativeFiles, function(file) {
            const uploadFileIdx = $scope.uploadFileSetIndex++;
            $scope.uploadFileSet.add(uploadFileIdx);
            CreativeServicePro.getImgSignature({
                flightId: flightId,
                fileName: file.name
            }).then(function(success) {
                const additionalParams = {
                    "from": "flight",
                    "flightId": flightId,
                    "libraryCreative": libraryCreative,
                    "file_name": file.name,
                    "file_size": file.size,
                    "isTasksPage": true,
                    "uploadFileIdx": uploadFileIdx,
                    "callback": callback,
                };
                if (adGroupMoreInfo) {
                    additionalParams.adGroupMoreInfo = adGroupMoreInfo;
                }
                $rs.$broadcast('cloudinaryImageUpload', success, file, additionalParams);
            }, function(error) {
                if (callback) {
                    callback(uploadFileIdx);
                }
                const details = JSON.stringify(error);
                $ioAlert.show('Error!', 'Could not get img signature.' + details, error);
                console.log(error);
            });

        });
    };

    const addClientCreativeAssets = function(clientId, creativeFiles, addToLibrary, callback) {
        let libraryCreative = "no";
        if (addToLibrary) {
            libraryCreative = "yes"
        }
        angular.forEach(creativeFiles, function(file, index) {
            if (index == 0) {
                $ioAlert.show('', "Creatives are being uploaded, please don't refresh the page. You can check the status in the notifications tab", 'success');
            }
            const uploadFileIdx = $scope.uploadFileSetIndex++;
            $scope.uploadFileSet.add(uploadFileIdx);
            CreativeServicePro.getImgSignature({
                clientId: clientId,
                fileName: file.name
            }).then(function(success) {
                const additionalParams = {
                    "from": "client",
                    "clientId": clientId,
                    "libraryCreative": libraryCreative,
                    "file_name": file.name,
                    "file_size": file.size,
                    "isTasksPage": true,
                    "uploadFileIdx": uploadFileIdx,
                    "callback": callback,
                };
                $rs.$broadcast('cloudinaryImageUpload', success, file, additionalParams);
            }, function(error) {
                if (callback) {
                    callback(uploadFileIdx);
                }
                const details = JSON.stringify(error);
                $ioAlert.show('Error!', 'Could not get img signature.' + details, error);
                console.log(error);
            });

        });
    };

    /*
     Attach Creatives for lineItem/Order/Flight
    */
    const attachCreatives = function(id, selectedCreatives, type, callback) {
        let method = 'assignToLineItem';
        if (type == 'order') {
            method = 'assignToOrder'
        } else if (type == 'flight') {
            method = 'assignToFlight'
        }
        const lastCreativeId = selectedCreatives[selectedCreatives.length - 1].id;
        for (let i = 0, len = selectedCreatives.length; i < len; i++) {
            let obj = {
                "creativeId": selectedCreatives[i].id
            };
            if (type == 'order') {
                obj.orderId = id;
            } else if (type == 'lineItem') {
                obj.lineItemId = id;
            } else if (type == 'flight') {
                obj.flightId = id;
            }
            const uploadFileIdx = $scope.uploadFileSetIndex++;
            $scope.uploadFileSet.add(uploadFileIdx);
            creativesService[method](obj).then(function(response) {
                if (response && response.errors) {
                    for (let j = 0, len = response.errors.length; j < len; j++) {
                        $ioAlert.show('Error', response.errors[j]);
                    }
                    $scope.model.creativelibrary = null;
                }
                if (callback) {
                    callback(uploadFileIdx);
                }
                /*
                Call Get creatives after all the requests are completed
                */
                if (response.creative && lastCreativeId == response.creative.creative_id) {
                    $scope.model.creativelibrary = null;
                    getCreatives();
                }
            }, function(error) {
                if (callback) {
                    callback(uploadFileIdx);
                }
                $ioAlert.show('ERROR!', 'Attaching creative failed. Please try again later.', 'error');
            });
        }
    };

    $scope.toggle = function() {
        if ($scope.caretClass == 'icon-caret-right')
            $scope.caretClass = "icon-caret-down";
        else
            $scope.caretClass = "icon-caret-right";
    };

    $scope.showChanges = function(changesObj) {
        $modal.open(
            ModalService.returnModalType('lineItemChanges', {
                data: {
                    list: changesObj.fieldAuditHistory
                }
            })
        )
    };

    var applyPermissions = function() {
        if ($rs.userRole.permissions.indexOf("vendor") > -1) {
            $scope.isVendor = true;
        }
    };

    /*
     * Update the due date for a task
     */
    $scope.updateDueDate = function() {
        $modal.open({
            animation: true,
            controller: 'UpdateDueDateModalController',
            templateUrl: modalUpdateDueDateHtmlUrl,
            resolve: {
                dueDate: function() {
                    return $scope.taskAssignment.due_date;
                }
            }
        }).result.then(function(data) {
            data = $filter('date')(data, 'yyyy-MM-dd');
            var obj = {
                "taskAssignmentId": $stateParams.taskId,
                "dueDate": data
            }
            TaskService.updateDueDate(obj).then(function(response) {
                if (response) {
                    $ioAlert.show("", "Due Date updated successfully", "success");
                    getTaskAssignment();
                }

            }, function(error) {
                console.log("Error updating due date");
                $ioAlert.show('ERROR!', 'Error updating Due date. Please try again later.', 'error');
            })
        })
    }

    function checkIfLookupValueIsNotIncludedInParent(lookupValue, parent) {
        if (!(parent && _.isFunction(parent.includes))) {
            return true;
        }

        if (Array.isArray(lookupValue)) {
            let returned = true;
            lookupValue.forEach(function(val) {
                returned = returned && !parent.includes(val);
            })

            return returned;
        }

        return !parent.includes(lookupValue);
    }

    var resolvePredefinedValue = function(key) {
        var val = null;
        var keyArray = key.split('_');
        var objectName = keyArray.shift();
        var prop = keyArray[0];

        // Need to rebuild object properties containing underscores
        if (keyArray.length > 1) {
            prop = keyArray.join('_');
        }

        switch (objectName) {
            case 'order':
                val = ($scope.order && $scope.order[prop]) ? $scope.order[prop] : 'NA';
                break;

            case 'lineItem':
                val = ($scope.lineItem && $scope.lineItem[prop]) ? $scope.lineItem[prop] : 'NA';
                break;

            case 'flight':
                val = ($scope.flight && $scope.flight[prop]) ? $scope.flight[prop] : 'NA';
                break;

            case 'client':
                val = ($scope.client && $scope.client[prop]) ? $scope.client[prop] : 'NA';
                break;
        }

        return val;
    };

    $scope.calculate = function(data) {
        if (data === undefined) {
            calQueueExc();
            return;
        }
        let dataArray = data.split(',');
        const fieldId = dataArray.shift();
        const formFieldsLen = $scope.formFields.length;
        let calculateFields = {
            'fieldId': parseInt(fieldId)
        };

        let getFamilyNestedCondition = function(field) {
            let condition = true;
            if (field.parentField) {
                let modelValue = $scope.model[field.parentField.field_name];
                let isConditionValueAnArray = Array.isArray(field.conditionValue);


                if (isConditionValueAnArray && field.parentField.input_type == 'checkbox' && _.isBoolean(modelValue)) {
                    modelValue = modelValue === true ? '1' : '0'
                }

                if (Array.isArray(modelValue)) {
                    condition = isConditionValueAnArray ?
                        modelValue.some(oneVal => field.conditionValue.includes(oneVal)) :
                        modelValue.includes(field.conditionValue)
                } else {
                    condition = isConditionValueAnArray ?
                        field.conditionValue.includes(modelValue) :
                        modelValue == (field.conditionValue);
                }
                condition = getFamilyNestedCondition(field.parentField) && condition;
            }
            return condition;
        }

        const numericTypes = ['integer', 'decimal', 'currency', 'percentage'];

        for (let i = 0; i < formFieldsLen; i++) {
            for (let j = 0, len = dataArray.length; j < len; j++) {
                if (parseInt(dataArray[j]) == $scope.formFields[i].id) {
                    const parameterName = 'ff' + $scope.formFields[i].id;
                    const field = $scope.formFields[i];
                    const condition = getFamilyNestedCondition(field);
                    const valueOfFieldInFormula = $scope.model[$scope.formFields[i].field_name];
                    if (valueOfFieldInFormula && condition) {
                        if ($scope.formFields[i].lookup_content) {
                            let formValue = valueOfFieldInFormula;
                            formValue = $scope.formFields[i].input_type == 'select2' ? formValue.text : formValue;
                            let lookupContentIds = FormService.getLookupContentIds(
                                $scope.formFields[i].field_name,
                                $scope.formFields[i].lookup_content,
                                formValue, false, $scope.model, $scope.formParentChildInfo);
                            if (Array.isArray(lookupContentIds)) {
                                lookupContentIds = lookupContentIds.length === 0 ? "" : lookupContentIds;
                                calculateFields[parameterName + "[]"] = lookupContentIds;
                            } else {
                                calculateFields[parameterName] = lookupContentIds;
                            }
                            // we do not need to handle symbol or format for ids in the formula
                        } else {
                            calculateFields[parameterName] = valueOfFieldInFormula;
                            // we need to handle symbol or format for numbers in the formula
                            if ($scope.formFields[i].data_type == "currency" &&
                                calculateFields[parameterName].contains("$")) {
                                calculateFields[parameterName] = calculateFields[parameterName].replace(/\$/g, '');
                            }
                            if ($scope.formFields[i].data_type == "percentage" &&
                                calculateFields[parameterName].contains('%')) {
                                calculateFields[parameterName] = calculateFields[parameterName].replace(/\%/g, '');
                            }
                            if (numericTypes.includes($scope.formFields[i].data_type)) {
                                calculateFields[parameterName] = calculateFields[parameterName].replace(/,/g, '');
                            }
                            if ($scope.formFields[i].data_type == "date") {
                                calculateFields[parameterName] = $filter('date')(calculateFields[parameterName], 'yyyy-MM-dd');
                            }
                            if ($scope.formFields[i].input_type == "timeselect") {
                                if (typeof valueOfFieldInFormula == 'object') {
                                    calculateFields[parameterName] = valueOfFieldInFormula.toLocaleTimeString();
                                }
                            }
                        }
                    } else {
                        calculateFields[parameterName] = 0;
                    }
                } else {
                    const predefinedValue = resolvePredefinedValue(dataArray[j]);

                    if (predefinedValue) {
                        const pname = 'ff' + dataArray[j];
                        calculateFields[pname] = predefinedValue;
                    }
                }
            }
        }

        if ($scope.order) {
            calculateFields['orderId'] = $scope.order.id;
        }
        if ($scope.lineItem) {
            calculateFields['lineItemId'] = $scope.lineItem.id;
        }
        if ($scope.flight) {
            calculateFields['flightId'] = $scope.flight.id;
            if ($scope.lineItemId) {
                calculateFields['lineItemId'] = $scope.lineItemId;
            }
            if ($scope.isFlightTask) {
                calculateFields['isFlightCalc'] = 1;
            }
        }

        // Even though it's called calculateOrder, it's actually for orders, tasks, and flights (anything using form fields).
        FormService.calculateOrder(calculateFields).then(function(success) {
            if (success) {
                if (angular.isUndefined(success.value) || success.status === 'fail') {
                    if (angular.isUndefined(success.message)) {
                        $ioAlert.show('', "Please make sure all required fields are filled in.", 'error');
                    } else {
                        $ioAlert.show('', success.message, 'error');
                    }                    success.value = '';
                    if (success.message) {
                        console.log(success.message);
                    }
                }

                $scope.formFields.forEach((field) => {
                    if (parseInt(fieldId) == field.id) {
                        switch (field.data_type) {
                            case 'currency':
                                $scope.model[field.field_name] = FormService.currencyFormating(
                                    String(success.value),
                                    true
                                );
                                break;
                            case 'integer':
                                $scope.model[field.field_name] = FormService.numberFormating(String(success.value), 0);
                                break;
                            case 'decimal':
                                $scope.model[field.field_name] = FormService.numberFormating(String(success.value));
                                break;
                            case 'percentage':
                                $scope.model[field.field_name] = String(success.value) + '%';
                                break;
                            case 'date':
                                $scope.model[field.field_name] = FormService.convertStringToDate(String(success.value));
                                break;
                            default:
                                $scope.model[field.field_name] = String(success.value);
                        }
                    }
                });
            }
            calQueueExc();
        }, function(error) {
            $ioAlert.show("Error!", "An error occurred calculating the fields.", 'error');
            $rs.loadingInProgress = false;
            calQueueExc();
        });
    };

    function calQueueExc() {
        if ($scope.calQueue.length > 0) {
            const fieldIds = $scope.calQueue.shift();
            $scope.calculate(fieldIds);
        } else if ($scope.calQueue.length == 0) {
            $rs.loadingInProgress = false;
        }
    }

    $scope.calculateAllFields = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Calculate Details";
        $scope.calQueue = [];
        for (let i = 0, len = $scope.entireForm.length; i < len; i++) {
            if ($scope.entireForm[i].items) {
                for (let j = 0, size = $scope.entireForm[i].items.length; j < size; j++) {
                    if ($scope.entireForm[i].items[j].fieldIds != undefined) {
                        const item = $scope.entireForm[i].items[j];
                        if (item.condition) {
                            const parent_name = item.conditionInfo.parent_name;
                            const lookupValue = item.conditionInfo.lookup_value;
                            const input_type = item.conditionInfo.input_type;

                            const isModelParentNameUndefined = $scope.model[parent_name] === undefined;
                            const isInputNotACheckbox = input_type != "checkbox";
                            const isLookupValueNotIncludedInParent = checkIfLookupValueIsNotIncludedInParent(lookupValue, $scope.model[parent_name]);


                            if (isModelParentNameUndefined || (isInputNotACheckbox && isLookupValueNotIncludedInParent)) {
                                continue;
                            }
                        }
                        if ($scope.entireForm[i].items[j].showOverride) {
                            if (!$scope.entireForm[i].items[j].override)
                                $scope.calQueue.push($scope.entireForm[i].items[j].fieldIds);
                        } else {
                            $scope.calQueue.push($scope.entireForm[i].items[j].fieldIds);
                        }
                    }
                }
            }
        }
        $scope.calQueue = FormService.reorderCalQueue($scope.calQueue);
        calQueueExc();
    };

    function getInstanceSettings_comments() {
        FormService.getInstanceSettings("role_sales_hide_sidebar").then(function(data) {
            if (data && data.id && ['sales', 'sales,admin'].includes($rs.userRole.permissions)) {
                $scope.showTasksComments = !(data.value === "1");
            } else {
                $scope.showTasksComments = true;
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $scope.showTasksComments = true;
        });
    }

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'disabled');
        if($stateParams.fromPage) {
            $scope.fromPage = $stateParams.fromPage;
        } else {
            $scope.fromPage = 'myTasks';
        }

        applyPermissions();
        getTaskAssignment();

        if ($stateParams.fromPage && $stateParams.fromPage == 'lineitem') {
            $scope.returnText = 'Return to Line Item';
        } else if ($stateParams.fromPage && $stateParams.fromPage == 'flight') {
            // flightId == 0 means that we'll return to the flights list page, but not display a particular flight.
            $scope.returnText = $stateParams.flightId == 0 ? 'Return to Flights' : 'Return to Flight';
        } else if ($stateParams.fromPage && $stateParams.fromPage == 'detailedOrders') {
            $scope.returnText = 'Return to Order Details';
        } else if ($stateParams.fromPage && $stateParams.fromPage == 'workflowclient') {
            $scope.returnText = 'Return to Client Workflow Details';
        } else {
            $scope.returnText = 'Return to Order';
        }
        // Show only for user_type superadmin and sales, salesmanager roles
        if ($rs.userRole.user_type === "superadmin" && $rs.userRole.permissions !== "sales" && $rs.userRole.permissions !== "sales,admin") {
            $scope.showTasksComments = true;
        } else {
            getInstanceSettings_comments();
        }
        
        if (['vendor', 'vendor_restricted'].indexOf($rs.userRole.predefined_role_key) > -1 ||
            ['vendor', 'vendor-restricted'].indexOf($rs.userRole.permissions) > -1) {
            $scope.user_is_vendor = true;
        }

        $('.toggler').click(function(e) {
            e.preventDefault();
            var $icon = $(this).find('span.icon');

            if ($icon.hasClass('icon-caret-right')) {
                $icon.removeClass('icon-caret-right').addClass('icon-caret-down');
            } else {
                $icon.removeClass('icon-caret-down').addClass('icon-caret-right');
            }
        });
    };

    CurrentUser.get().then(function(user) {
        $scope.user = user;
        if ($rs.userRole && $rs.userRole.id) {
            init();
        } else {
            UserService.getCurrentUserRole().then(function() {
                $rs.userRole = UserService.userRole;
                init();
            }, function() {});
        }
    })
}

MyTasksController.$inject = ['$rootScope', '$scope', '$timeout', '$modal', 'TaskService', '$state',
    'UserService', '$filter', 'CommentService', 'ClusterService', 'DateRangeService', '$ioAlert',
    'ModalService', 'filterFilter', 'InstanceSettings', 'FormService', 'CurrentUser', 'AppConfig'];

function MyTasksController($rs, $scope, $timeout, $modal, TaskService, $state, UserService,
                           $filter, CommentService, ClusterService, DateRangeService, $ioAlert,
                           ModalService, filterFilter, InstanceSettings, FormService, CurrentUser, AppConfig) {
    $scope.tasks = [];
    $scope.restrictOrders = false;
    $scope.isVendor = false;
    $scope.showClosedTasks = false;
    $scope.isFilteringTasks = false;
    $scope.sortReverse = false;
    $scope.sortType = 'due_date';
    $scope.isAdmin = false;
    $scope.accessToManager = false;
    $scope.isOrderCentric = false;
    $scope.enableTaskIcons = false;
    $scope.hasFlights = false;
    $scope.selectedTasks = [];
    $scope.taskAssignmentHistory = [];
    $scope.pageObj = {
        perPageOptions: [5, 10, 25, 50, 100],
        perPage: 100,
        currentPage: 1,
        totalCount: 0,
        orderBy: 'due_date',
        startIndex: 1,
        endIndex: 1,
        maxSize: 5,
        calculate: function() {
            $scope.pageObj.startIndex = Math.ceil((($scope.pageObj.currentPage - 1) * $scope.pageObj.perPage) + 1);
            $scope.pageObj.endIndex = Math.min(($scope.pageObj.currentPage) * $scope.pageObj.perPage);
            if ($scope.pageObj.endIndex > $scope.pageObj.totalCount) {
                $scope.pageObj.endIndex = $scope.pageObj.totalCount;
            }
        }
    };
    $scope.delegate = {
        onApplyFilter(filter) {
            $scope.getTaskAssignments(filter)
        },
        onResetFilter() {
            $scope.getTaskAssignments()
        }
    }

    $scope.$watch("pageObj.currentPage + pageObj.perPage", function() {
        $scope.updatePagination($scope.pageObj.currentPage, $scope.pageObj.perPage);
    });

    $scope.updatePagination = function(currentPage, perPage) {
        var begin = ((currentPage - 1) * perPage),
            end = begin + perPage;

        $scope.filteredTasks = $scope.tasks.slice(begin, end);
    };

    // Custom comparator for ng-repeat.  Only necessary for the line_item_id column.
    $scope.customTaskListCompare = function(a, b) {
        if ($scope.sortType.startsWith('line_item_id') && a.type === 'string' && b.type === 'string') {
            return a.value.localeCompare(b.value, navigator.languages[0] || navigator.language, {
                numeric: true,
                ignorePunctuation: true
            });
        } else {
            return (a.value < b.value) ? -1 : 1;
        }
    };

    $scope.updateSearch = function() {
        if ($scope.searchTasks) {
            $scope.filteredTasks = filterFilter($scope.tasks, $scope.searchTasks);
        } else {
            $scope.updatePagination(1, $scope.pageObj.perPage);
        }
    };

    let clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        InstanceSettings.getTasksAssignmentsDefaultFilterValue(function (filter) {
            $scope.loadTaskAssignments(filter)
        }, function () {
            $scope.loadTaskAssignments()
        })
    });

    $scope.loadTaskAssignments = function(filter = false) {
        $scope.selectedTasks = [];
        $scope.enableTaskIcons = false;
        if ($scope.showClosedTasks) {
            $scope.getClosedTasks();
        } else {
            $scope.getTaskAssignments(filter);
        }
    };

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    // Only show active & followed task assignments
    $scope.getTaskAssignments = function(filter = false) {

        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching My Open Tasks";

        $scope.showClosedTasks = false;
        $scope.tasks = [];
        $scope.hasFlights = false;

        let clusterIds = null;

        // Show vendor tasks across all clusters
        if (!$scope.isVendor && ClusterService.clusterIds && ClusterService.clusterIds.length) {
            clusterIds = ClusterService.clusterIds;
        }

        let params = {};
        if (clusterIds) {
            params["clusterIds"] = clusterIds
        }

        if (filter) {
            params.filter = filter
        }

        // Commented by Anudep for TA-8036
        // TODO: Need to handle backend pagination with search
        // Currently handling in the frontend for production fix

        /*params.page = $scope.pageObj.currentPage;
        params.perPage = $scope.pageObj.perPage;
        params.orderBy = $scope.pageObj.orderBy;*/
        TaskService.getOpenTaskAssignmentsForCurrentUser(params).then(function(success) {
            $scope.tasks = TaskService.taskAssignments;

            $scope.pageObj.totalCount = $scope.tasks.length;
            $scope.pageObj.currentPage = 1;
            $scope.pageObj.calculate();
            $scope.updatePagination(1, $scope.pageObj.perPage);

            delete params["clusterIds[]"];
            delete params["clusterIds"];
            TaskService.getFollowedTaskAssignmentsForCurrentUser(params).then(function(success) {
                if (TaskService.taskAssignments) {
                    $scope.tasks = $scope.tasks.concat(TaskService.taskAssignments);
                }
                $scope.loadFail = false;

                //set the ids as numbers and not strings for proper sorting
                if ($scope.tasks.length > 0) {
                    for (let i = 0, len = $scope.tasks.length; i < len; i++) {
                        $scope.tasks[i].id = parseInt($scope.tasks[i].id);
                        let order_id = $scope.tasks[i].order_id;
                        $scope.tasks[i].order_id = order_id ? parseInt(order_id) : ' ';
                        $scope.tasks[i].priority = parseInt($scope.tasks[i].priority);
                        if ($scope.tasks[i].task_created_date) {
                            var task_created_date = $scope.tasks[i].task_created_date.split(' ');
                            $scope.tasks[i].task_created_date = new Date(task_created_date[0] + " 00:00:00");
                        }
                        if ($scope.tasks[i].due_date) {
                            $scope.tasks[i].due_date = new Date($scope.tasks[i].due_date + " 00:00:00");
                        }
                        if ($scope.tasks[i].flight_id) {
                            $scope.hasFlights = true;
                        }
                    }
                }
                const groups = _.groupBy($scope.tasks, "order_id");
                $scope.groups = [];
                Object.keys(groups).forEach(key => {
                    $scope.groups.push({order_id: key});
                    groups[key].forEach((group) => {
                        $scope.groups.push(group);
                    });
                });
                $rs.loadingInProgress = false;

            }, function(error) {
                console.log("Error getting task assignments for the current user");
                $rs.loadingInProgress = false;

            });
        }, function(error) {
            console.log("Error getting task assignments for the current user");
            $rs.loadingInProgress = false;
        });
    };

    $scope.startTask = function(taskAssignment) {
        TaskService.assignToCurrentUser(taskAssignment.id).then(function(success) {
            $scope.openTask(taskAssignment);
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
        });
    };

    $scope.swapView = function() {
        $scope.isOrderCentric = !$scope.isOrderCentric;
    };

    $scope.openTask = function(task) {
        $state.go('myTasksView', {
            taskId: task.id
        });
    };

    $scope.openOrder = function(task) {
        $state.go('myTasksOrder', {
            taskId: task.id,
            id: task.order_id
        });
    };

    $scope.openLineItem = function(task) {
        $state.go('myTasksLineitem', {
            taskId: task.id,
            lineItemId: task.reference_table_row_id
        });
    };

    $scope.getClosedTasks = function() {

        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching My closed Tasks";
        $scope.showClosedTasks = true;
        $scope.tasks = [];

        var clusterIds = null;

        // Show vendor tasks across all clusters
        if (!$scope.isVendor && ClusterService.clusterIds && ClusterService.clusterIds.length) {
            clusterIds = ClusterService.clusterIds;
        }

        var params = {};
        if (clusterIds) {
            params = {
                "clusterIds": clusterIds
            }
        }
        /*params.page = $scope.pageObj.currentPage;
        params.perPage = $scope.pageObj.perPage;
        params.orderBy = $scope.pageObj.orderBy;*/

        TaskService.getClosedTaskAssignmentsForCurrentUser(params).then(function(success) {
            $scope.tasks = TaskService.taskAssignments;
            _.each($scope.tasks, function(task) {
                task.id = parseInt(task.id);
                task.order_id = parseInt(task.order_id);
                if (task.task_created_date) {
                    task.task_created_date = new Date(task.task_created_date.split(' ')[0] + " 00:00:00");
                };
            });
            $rs.loadingInProgress = false;
            $scope.pageObj.totalCount = $scope.tasks.length;
            $scope.pageObj.currentPage = 1;
            $scope.pageObj.calculate();
            $scope.updatePagination(1, $scope.pageObj.perPage);

        }, function(error) {
            console.log("Error getting task assignments for the current user");
            $rs.loadingInProgress = false;
        });
    };

    $scope.goToNewTasks = function() {
        window.location = `${AppConfig.NUI_PATH}#/tasks`;
    };
    $scope.canAccessNewTasks = function() {
        return $rs.userRole.io_tool_module_available && $rs.userRole.stellar_module_available;
    };

    $scope.updateStatus = function(task) {
        if (task) {
            var taskStatus = 'close';
            if ($scope.showClosedTasks) {
                taskStatus = 'open'
            }
            $state.go('managementTools', {
                'taskId': task.id,
                'taskStatus': taskStatus
            });
        }
    };
    function getInstanceSettings_comments() {
        FormService.getInstanceSettings("role_sales_hide_sidebar").then(function(data) {
            if (data && data.id && ['sales', 'sales,admin'].includes($rs.userRole.permissions)) {
                $scope.showTasksComments = !(data.value === "1");
            } else {
                $scope.showTasksComments = true;
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $scope.showTasksComments = true;
        });
    }
    $scope.selectTask = function(id) {
        if (!id) {
            return;
        }
        const index = $scope.selectedTasks.indexOf(id);
        if (index >= 0) {
            $scope.selectedTasks.splice(index, 1);
            $scope.enableTaskIcons = ($scope.selectedTasks.length != 0);
        } else {
            $scope.enableTaskIcons = true;
            $scope.selectedTasks.push(id);
        }
    };

    $scope.commentOnTaskAssignments = function() {
        var taskIds = [];
        angular.forEach($scope.tasks, function(task) {
            if ($scope.selectedTasks.indexOf(task.id) !== -1) {
                taskIds.push(task.id);
            }
        });
        if (taskIds.length > 0) {
            var modalInstance = $modal.open(
                ModalService.returnModalType('comment', {
                    data: {
                        titleText: 'Add Comment',
                        buttonText: 'Save'
                    }
                })
            );
            modalInstance.result.then(function(comment) {
                CommentService.addCommentOnTasks(taskIds, comment).then(function(success) {
                    $ioAlert.show('', 'Comment posted successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                });
            }, function() {});
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    $scope.completeTaskAssignments = function() {
        var taskIds = [];
        var taskError = null;
        angular.forEach($scope.tasks, function(task) {
            if ($scope.selectedTasks.indexOf(task.id) !== -1) {
                if (task.time_tracking == '1' && task.time_tracking_required == '1' && (task.logged_time == null || task.logged_time == '0')) {
                    taskError = 'Some tasks could not be completed: Task(s) need Work Time logged !';
                } else {
                    taskIds.push(task.id);
                }
            }
        });
        if (taskError) {
            $ioAlert.show('Warning!', taskError, 'error');
        }
        if (taskIds.length > 0) {
            var modalInstance = $modal.open(
                ModalService.returnModalType('comment', {
                    data: {
                        titleText: 'Complete Tasks',
                        buttonText: 'Complete'
                    }
                })
            );
            modalInstance.result.then(function(comment) {
                if (comment !== '') {
                    CommentService.addCommentOnTasks(taskIds, comment).then(function(success) {}, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                    });
                }
                TaskService.completeTaskAssignments(taskIds).then(function(success) {
                    if (TaskService.errors) {
                        for (var x = 0; x < TaskService.errors.length; x++) {
                            $ioAlert.show("Error", TaskService.errors[x], "error");
                        }
                        TaskService.errors = null;
                    } else {
                        $scope.loadTaskAssignments();
                        $ioAlert.show('', 'The selected tasks were successfully completed', 'success');
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                });
            }, function() {});
        } else if (!taskError) {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    $scope.assignTaskAssignments = function() {
        var taskIds = [];
        var queueIds = [];
        angular.forEach($scope.tasks, function(task) {
            if ($scope.selectedTasks.indexOf(task.id) !== -1) {
                taskIds.push(task.id);
                queueIds.push(task.queue_id);
            }
        });
        if (taskIds.length > 0) {
            UserService.getUsersForQueues(queueIds, ClusterService.clusterIds).then(function(success) {
                UserService.users?.forEach((user) => {
                    user.full_name = user.first_name + ' ' + user.last_name;
                });
                const modalInstance = $modal.open(
                    ModalService.returnModalType('reassign', {
                        data: {
                            items: UserService.users
                        }
                    })
                );
                modalInstance.result.then(function(user) {
                    TaskService.assignTaskAssignments(taskIds, user.id).then(function(success) {
                        var assigned_user_name = user.first_name + ' ' + user.last_name;
                        angular.forEach($scope.tasks, function(task) {
                            if (taskIds.indexOf(task.id) != -1) {
                                task.assigned_user_name = assigned_user_name;
                                task.status_name = 'Assigned';
                            }
                        });
                        $ioAlert.show('', 'The selected tasks were successfully assigned to ' + assigned_user_name, 'success');
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                    });
                }, function() {});
            }, function(error) {
                console.log("Error getting users for queue");
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    $scope.incrementTaskAssignmentsPriority = function() {
        if ($scope.selectedTasks.length > 0) {
            TaskService.incrementTaskAssignmentsPriority($scope.selectedTasks).then(function(success) {
                if (success.errors) {
                    $ioAlert.show('Warning!', 'One or More Tasks have reached maximum priority value', 'error');
                    $scope.loadTaskAssignments();
                } else {
                    if (success.taskAssignments) {
                        $scope.loadTaskAssignments();
                        $ioAlert.show('', 'Priority successfully incremented', 'success');
                    } else {
                        $ioAlert.show('Error!', 'Failed to increment priority', 'error');
                    }
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Failed to increment priority', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    $scope.decrementTaskAssignmentsPriority = function() {
        if ($scope.selectedTasks.length > 0) {
            TaskService.decrementTaskAssignmentsPriority($scope.selectedTasks).then(function(success) {
                if (success.errors) {
                    $ioAlert.show('Warning!', 'One or More Tasks have reached minimum priority value', 'error');
                    $scope.loadTaskAssignments();
                } else {
                    if (success.taskAssignments) {
                        $scope.loadTaskAssignments();
                        $ioAlert.show('', 'Priority successfully decremented', 'success');
                    }
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Failed to decrement priority', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    /*
    * Handle showing task assignment history
    */
    var showTaskAssignmentHistory = function(task) {
        $modal.open({
            animation: true,
            controller: function($scope, $modalInstance, taskAssignmentHistory){

                $scope.taskHistory = taskAssignmentHistory.history;
                $scope.task = taskAssignmentHistory.task;

                // Close the modal popup
                $scope.cancel = function() {
                    $modalInstance.dismiss();
                };
            },
            templateUrl: taskAssignmentHistoryHtmlUrl,
            backdrop: 'static',
            size: 'lg',
            resolve: {
                taskAssignmentHistory: function() {
                    return {
                        history: $scope.taskAssignmentHistory,
                        task: task
                    };
                }
            },
            windowClass: 'magictime zoomInSmooth modal-overflow in'
        }).result.then(function(data) {})
    }

    /*
     * Update the due date for a task
     */
    $scope.updateDueDate = function() {
        if ($scope.selectedTasks.length > 0) {
            $modal.open({
                animation: true,
                controller: 'UpdateDueDateModalController',
                templateUrl: modalUpdateDueDateHtmlUrl,
                resolve: {
                    dueDate: function() {
                        return '';
                    }
                }
            }).result.then(function(data) {
                data = $filter('date')(data, 'yyyy-MM-dd');

                var obj = {
                    "taskAssignmentIds": $scope.selectedTasks,
                    "dueDate": data
                }
                TaskService.updateMultipleDueDates(obj).then(function(success) {
                    if (success.errors) {
                        $ioAlert.show('Warning!', 'Failed to update due dates', 'error');
                        $scope.loadTaskAssignments();
                    } else {
                        if (success.task_assignment_ids) {
                            $scope.loadTaskAssignments();
                            $ioAlert.show('', 'Due Dates updates successfully', 'success');
                        }
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Failed to update due dates', 'error');
                });
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    }

    /*
    *  Handle get task assignments history
    */
    $scope.getTaskAssignmentHistory = function(task) {
        TaskService.getTaskAssignmentHistory(task.id).then(function(response) {
            if(response) {
                $scope.taskAssignmentHistory = response;

                _.each($scope.taskAssignmentHistory, function(history) {

                    //build action user full name
                    if(history.action_user_first_name && history.action_user_last_name) {
                        history.action_user_full_name = history.action_user_first_name + ' ' + history.action_user_last_name;
                    } else if(history.action_user_first_name) {
                        history.action_user_full_name = history.action_user_first_name;
                    } else if(history.action_user_last_name) {
                        history.action_user_full_name =  history.action_user_last_name;
                    } else {
                        history.action_user_full_name = 'System';
                    }

                    //build assigned user full name
                    if(history.assigned_user_first_name && history.assigned_user_last_name) {
                        history.assigned_user_full_name = history.assigned_user_first_name + ' ' + history.assigned_user_last_name;
                    } else if(history.assigned_user_first_name) {
                        history.assigned_user_full_name = history.assigned_user_first_name;
                    } else if(history.assigned_user_last_name) {
                        history.assigned_user_full_name =  history.assigned_user_last_name;
                    } else {
                        history.assigned_user_full_name = 'Unassigned';
                    }
                })

                showTaskAssignmentHistory(task);
            }
        }, function(error) {
            console.log("Error getting task assignment history");
            $ioAlert.show('ERROR!', 'Error getting task assignment history. Please try again later.', 'error');
        })
    }

    function init() {
        $scope.loadFail = true;
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters');
        DateRangeService.init();
        //show only for user_type superadmin and sales, salesmanager roles
        if($rs.userRole.user_type === "superadmin" && $rs.userRole.permissions !== "sales" && $rs.userRole.permissions !== "sales,admin"){
            $scope.showTasksComments = true;
        }else{
            getInstanceSettings_comments();
        }
        if ($rs.userRole.permissions == 'vendor' || $rs.userRole.permissions == 'vendor-restricted') {
            $scope.restrictOrders = true;
            $scope.isVendor = true;
        }
        if ($rs.userRole.permissions == 'superadmin' || $rs.userRole.permissions == 'adops,admin') {
            $scope.isAdmin = true;
        }

        if ($rs.userRole.permissions == 'adops,admin') {
            FormService.getInstanceSettings("restrict_access_to_status_manager").then(function(data) {
                if (data && data.id) {
                    $scope.accessToManager = data.value === "0";
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Failed to get instance setting restrict_access_to_status_manager', 'error');
            });
        } else if ($rs.userRole.permissions == 'superadmin' ) {
            $scope.accessToManager = true;
        }
    }

    CurrentUser.get().then(function (user) {
        $scope.currentUser = user
        if ($rs.userRole && $rs.userRole.id) {
            init();
        } else {
            UserService.getCurrentUserRole().then(function() {
                $rs.userRole = UserService.userRole;
                init();
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }
    })
}

AdminTasksController.$inject = ['$scope', '$rootScope', '$state', 'TaskService', '$stateParams', '$ioAlert', '$confirm', 'QueuesService', 'UserService', 'ClusterService', 'DateRangeService', 'filterFilter', 'FormService'];

function AdminTasksController($scope, $rs, $state, TaskService, $stateParams, $ioAlert, $confirm, QueuesService, UserService, ClusterService, DateRangeService, filterFilter, FormService) {
    $scope.tasksList = [];
    $scope.loadFail = false;
    $scope.queuesList = [];
    $scope.searchTask = "";
    $scope.refTables = [];
    $scope.disableBtnAction = false;

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        getQueuesList(ClusterService.clusterIds[0]);
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    $scope.getReferenceTables = function() {
        TaskService.getReferenceTables().then(function(data) {
            $scope.refTables = data;
        }, function(error) {
            console.log("error loading reference tables");
        });
    };

    $scope.getTasks = function() {
        TaskService.getTasksList().then(function(success) {
            var tasks = TaskService.tasksList;
            if ($scope.refTables.length > 0) {
                $scope.taskMapping(tasks);
                $rs.loadingInProgress = false;
            } else {
                TaskService.getReferenceTables().then(function(data) {
                    $scope.refTables = data;
                    $scope.taskMapping(tasks);
                    $rs.loadingInProgress = false;

                }, function(error) {
                    $rs.loadingInProgress = false;
                    console.log("error loading reference tables");
                });
            }
        });
    };

    $scope.filterData = function(text) {
        if (!text || text.length < 2) {
            return;
        }
        $scope.tasksList = _.groupBy(filterFilter($scope.tasksArr, text), "queue_name");
    }

    $scope.taskMapping = function(tasks) {
        for (var i = 0, len = tasks.length; i < len; i++) {
            for (var j = 0, size = $scope.queuesList.length; j < size; j++) {
                if (tasks[i].queue_id == $scope.queuesList[j].id) {
                    tasks[i].queue_name = $scope.queuesList[j].name;
                    break;
                }
            }
            if ($scope.refTables[tasks[i].reference_table]) {
                tasks[i].reference_table = $scope.refTables[tasks[i].reference_table];
            }
        }
        $scope.tasksArr = tasks;
        $scope.tasksList = _.groupBy(tasks, "queue_name");
    }

    var getQueuesList = function(clusterId) {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Tasks";
        $scope.getReferenceTables();
        QueuesService.getQueues(clusterId).then(function(success) {
            $scope.queuesList = QueuesService.queues;
            $scope.getTasks();
        }, function(error) {
            console.log("error loading queues list");
        });
    };

    $scope.addTask = function() {
        $state.go('addAdminTasks');
    };

    $scope.editTask = function(task) {
        if (task) {
            $state.go('editAdminTasks', {
                "id": task.id
            });
        }
    };

    $scope.toggleTaskStatus = function(taskId) {
        var param = {
            "id": taskId
        };
        $confirm.open({
            size: 'sm',
            text: 'Are you sure you want to delete this Task?'
        }).then(function() {
            TaskService.toggleTaskState(param).then(function(success) {
                $scope.getTasks();
                $ioAlert.show('Task Deleted', 'Task has been deleted successfully', 'success');
            }, function(error) {
                console.log("error updating tasks state");
            });
        }, function() {})
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
    UserService.adjustStickyHeaderWindowResize();
    var init = function() {
        ClusterService.initCluster($rs.userRole);
        DateRangeService.init();

        if ($stateParams.message) {
            $ioAlert.show("", $stateParams.message, 'success');
        }
        getInstanceLockConfig();
        UserService.adjustStickyHeader();

    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}

AddAdminTasksController.$inject = ['$scope', '$rootScope', '$stateParams', 'TaskService', 'UserService', '$state', '$ioAlert', 'QueuesService', 'ClusterService', 'DateRangeService', 'IntegrationsService', 'FormService'];

function AddAdminTasksController($scope, $rs, $stateParams, TaskService, UserService, $state, $ioAlert, QueuesService, ClusterService, DateRangeService, IntegrationsService, FormService) {
    const dueDateDependencyId = {
        ORDER_START_DATE: "3",
        ORDER_END_DATE: "4",
        LINE_ITEM_START_DATE: "6",
        LINE_ITEM_END_DATE: "7",
        FLIGHT_START_DATE: "12",
        FLIGHT_END_DATE: "13",
    };
    $scope.newTaskObj = {};
    $scope.taskId = $stateParams.id;

    if ($scope.taskId) {
        $scope.isNew = false;
        $scope.tasksText = "Edit Task";
        $scope.btnText = "Update";
        $scope.newTaskObj.id = $scope.taskId;
    } else {
        $scope.isNew = true;
        $scope.btnText = "Save";
        $scope.tasksText = "Add Task";
        $scope.newTaskObj.validate = true;
    }
    $scope.refTables = [];
    $scope.vendorsList = [];
    $scope.queuesList = [];
    $scope.eventsList = [];

    $scope.isBeforeDisabled = true;
    const beforeValues = [
        dueDateDependencyId.ORDER_START_DATE,
        dueDateDependencyId.ORDER_END_DATE,
        dueDateDependencyId.LINE_ITEM_START_DATE,
        dueDateDependencyId.LINE_ITEM_END_DATE,
        dueDateDependencyId.FLIGHT_START_DATE,
        dueDateDependencyId.FLIGHT_END_DATE,
    ];

    $scope.toggle = {};
    $scope.toggle.activeBusinessDays = true;
    $scope.newTaskObj.useBusinessDays = 1;
    $scope.adminTasksTemplate = adminTasksHtmlUrl;
    $scope.disableBtnAction = false;
    $scope.calendarFeatureEnabled = $rs.util.isModuleAvailable('iotool_cal_events');
    $scope.remoteTaskCompletionEnabled = false;

    $scope.toggleManageDueDays = function(){
        if($scope.newTaskObj.useBusinessDays){
            $scope.newTaskObj.useBusinessDays = 0;
        }else{
            $scope.newTaskObj.useBusinessDays = 1;
        }
    }

    $scope.backToTasks = function(message) {
        if (message) {
            $state.go('adminTasks', {
                'message': message
            });
        } else {
            $state.go('adminTasks');
        }
    };

    $scope.addNewQueue = function() {
        $state.go('addAdminQueues', {
            'comeFrom': 'adminTask',
            'taskInfo': $scope.newTaskObj,
        });
    };

    /*
     * Helper function to disable enable before and after radio buttons
     */
    $scope.updateBeforeAfter = function() {
        if (_.indexOf(beforeValues, $scope.newTaskObj.dueDateDependencyId) > -1) {
            $scope.isBeforeDisabled = false;
        } else {
            $scope.isBeforeDisabled = true;
            if ($scope.newTaskObj.dueDateRule == "before") {
                $scope.newTaskObj.dueDateRule = "";
            }
        }
    }

    /*
     * Reset TaskDue Dates when the checkbox is unchecked
     */
    $scope.resetTaskDueDate = function() {
        if ($scope.newTaskObj.escalatable) {
            $scope.newTaskObj.dueDateRuleNumDays = "";
            $scope.newTaskObj.dueDateDependencyId = "";
            $scope.newTaskObj.dueDateRule = "";
            $scope.newTaskObj.escalateNumDaysBefore = "";
            $scope.newTaskObj.useBusinessDays = 1;
        }
    };

    $scope.getTaskDetails = function(taskId) {
        TaskService.getTask(taskId).then(function(sucess) {
            $scope.formatObj(TaskService.task);
            $scope.updateBeforeAfter();
        }, function(error) {
            $ioAlert.show("Error!", "An error occurred retrieving the task details", 'error');
        });
    };

    var getReferenceTables = function() {
        TaskService.getReferenceTables().then(function(data) {
            $scope.refTables = data;
        }, function(error) {
            console.log("error loading reference tables");
        });
    };

    var getVendorsList = function() {
        TaskService.getVendorsList().then(function(data) {
            $scope.vendorsList = data.sort();
        }, function(error) {
            console.log("error loading reference tables");
        });
    };

    function getEventNames() {
        IntegrationsService.getEventNames().then(function(data) {
            $scope.eventsList = data;
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    function getDueDateDependencies() {
        TaskService.getDueDateDependencies().then(function(data) {
            $scope.dueDaysFromList = data;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        })
    }

    var getQueuesList = function(clusterId) {
        QueuesService.getQueues(clusterId).then(function(success) {
            $scope.queuesList = QueuesService.queues;
        }, function(error) {
            $ioAlert.show('Error!', "Error loading queues list.", 'error');
        });
    };

    $scope.formatObj = function(obj) {
        let keys = Object.keys(obj);
        let time_estimate = '0:0';
        for (let i = 0, len = keys.length; i < len; i++) {
            switch (keys[i]) {
                case 'name':
                    $scope.newTaskObj.name = obj[keys[i]];
                    break;
                case 'queue_id':
                    $scope.newTaskObj.queueId = obj[keys[i]];
                    break;
                case 'definition':
                    $scope.newTaskObj.definition = obj[keys[i]];
                    break;
                case 'reference_table':
                    $scope.newTaskObj.referenceTable = obj[keys[i]];
                    break;
                case 'vendor_name':
                    $scope.newTaskObj.vendorName = obj[keys[i]];
                    break;
                case 'autofire_webhook':
                    $scope.newTaskObj.autofireWebhook = obj[keys[i]];
                    break;
                case 'rejectable':
                    $scope.newTaskObj.rejectable = (obj[keys[i]] == 1);
                    break;
                case 'instructions':
                    $scope.newTaskObj.instructions = obj[keys[i]];
                    break;
                case 'time_tracking':
                    $scope.newTaskObj.timeTracking = (obj[keys[i]] == 1);
                    break;
                case 'time_tracking_estimate':
                    time_estimate = obj[keys[i]];
                    break;
                case 'time_tracking_required':
                    $scope.newTaskObj.timeTrackingRequired = (obj[keys[i]] == 1);
                    break;
                case 'create_goal':
                    $scope.newTaskObj.createGoal = (obj[keys[i]] == 1);
                    break;
                case 'validate':
                    $scope.newTaskObj.validate = (obj[keys[i]] == 1);
                    break;
                case 'link_service_mapper':
                    $scope.newTaskObj.linkServiceMapper = (obj[keys[i]] == 1);
                    break;
                case 'escalatable':
                    $scope.newTaskObj.escalatable = (obj[keys[i]] == 1);
                    break;
                case 'connect_calendar':
                    $scope.newTaskObj.connectCalendar = (obj[keys[i]] == 1);
                    break;
                case 'due_date_dependency_id':
                    $scope.newTaskObj.dueDateDependencyId = obj[keys[i]];
                    break;
                case 'due_date_rule_num_days':
                    $scope.newTaskObj.dueDateRuleNumDays = parseInt(obj[keys[i]]);
                    break;
                case 'due_date_rule':
                    $scope.newTaskObj.dueDateRule = obj[keys[i]];
                    break;
                case 'escalate_num_days_before':
                    $scope.newTaskObj.escalateNumDaysBefore = parseInt(obj[keys[i]]);
                    break;
                case 'event_names':
                    $scope.newTaskObj.eventNames = JSON.parse(obj[keys[i]]);
                    break;
                case 'use_business_days':
                    $scope.newTaskObj.useBusinessDays = JSON.parse(obj[keys[i]]);
                    break;
                case 'enable_comment_snapshot':
                    $scope.newTaskObj.enableCommentSnapshot = (obj[keys[i]] == 1);
                    break;
                case 'enable_remote_completion':
                    $scope.newTaskObj.enableRemoteCompletion = (obj[keys[i]] == 1);
                    break;
                case 'add_files_notifications':
                    $scope.newTaskObj.addFilesNotifications = (obj[keys[i]] == 1);
                    break;
            }
        }
        if ($scope.newTaskObj.timeTracking) {
            setTimeTrackingEstimate(time_estimate);
        }
    };

    $scope.saveTask = function(taskForm) {
        if (taskForm.$valid) {
            let params = JSON.parse(JSON.stringify($scope.newTaskObj));
            if (params.rejectable == true) {
                params.rejectable = 1;
            } else {
                params.rejectable = 0;
            }

            if (params.timeTracking == true) {
                params.timeTracking = 1;
            } else {
                params.timeTracking = 0;
            }

            if (params.timeTrackingRequired == true) {
                params.timeTrackingRequired = 1;
            } else {
                params.timeTrackingRequired = 0;
            }

            if (params.createGoal == true) {
                params.createGoal = 1;
            } else {
                params.createGoal = 0;
            }

            if (params.connectCalendar == true) {
                params.connectCalendar = 1;
            } else {
                params.connectCalendar = 0;
            }

            if (params.enableCommentSnapshot == true) {
                params.enableCommentSnapshot = 1;
            } else {
                params.enableCommentSnapshot = 0;
            }

            if (params.enableRemoteCompletion == true) {
                params.enableRemoteCompletion = 1;
            } else {
                params.enableRemoteCompletion = 0;
            }

            if (params.addFilesNotifications == true) {
                params.addFilesNotifications = 1;
            } else {
                params.addFilesNotifications = 0;
            }

            if (params.linkServiceMapper == true) {
                params.linkServiceMapper = 1;
            } else {
                params.linkServiceMapper = 0;
            }

            if (params.validate == true) {
                params.validate = "yes";
            } else {
                params.validate = "no";
            }
            if (params.eventNames) {
                params.eventNames = JSON.stringify(params.eventNames);
            }
            if (params.escalatable == true) {
                params.escalatable = 1;
            } else {
                params.escalatable = 0;
            }
            if ($scope.isNew) {
                TaskService.saveTask(params).then(function(success) {
                    $ioAlert.show("Success!", "Task " + success.task.definition + " has been created.", 'success');
                    $scope.isNew = true;
                    $scope.btnText = "Save";
                    $scope.tasksText = "Add Task";
                    $scope.newTaskObj = {
                        "validate": true
                    };
                    //$scope.backToTasks("Task Created Successfully");
                }, function(error) {
                    $ioAlert.show("Error!", "An error occurred saving the task", 'error');
                });
            } else {
                TaskService.updateTask(params).then(function(success) {
                    $scope.backToTasks("Task " + success.task.definition + " has been updated.");
                }, function(error) {
                    $ioAlert.show("Error!", "An error occurred updating the task", 'error');
                });
            }
        } else {
            $ioAlert.show("Validation Error!", "Please fill in the required fields", 'error');
        }
    };

    let setTimeTrackingEstimate = function(estimate) {
        if (!estimate) {
            return;
        }
        const time = estimate.split(':');
        $scope.newTaskObj.timeTrackingH = parseInt(time[0]); // needs integer, input type is number
        $scope.newTaskObj.timeTrackingM = parseInt(time[1]);
    }

    let getRemoteCompletionInstanceSetting = function() {
        FormService.getInstanceSettings("remote_task_completion_enabled").then(function(data) {
            if (data && data.id) {
                $scope.remoteTaskCompletionEnabled = (data.value === "1");
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'singleSelect').then(function() {
            DateRangeService.init();
            getReferenceTables();
            getVendorsList();
            getQueuesList(ClusterService.clusterIds[0]);
            getEventNames();
            getDueDateDependencies();
            if ($scope.taskId) {
                $scope.getTaskDetails($scope.taskId);
            } else if ($stateParams.taskInfo) {
                $scope.newTaskObj = $stateParams.taskInfo;
            }
            getInstanceLockConfig();
            getRemoteCompletionInstanceSetting();
        });
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}

UpdateDueDateModalController.$inject = ['$scope', '$modalInstance', 'dueDate'];

function UpdateDueDateModalController($scope, $modalInstance, dueDate) {
    $scope.dueDate = dueDate;
    $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1,
        showWeeks: false
    };

    $scope.update = function() {
        $modalInstance.close($scope.dueDate);
    };

    // Close the modal popup
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    function initController() {

    };

    initController();
};
